import { Section } from './SectionData';
import { SECTION_CATEGORIES } from './sectionTypes';

export const SAMPLE_SECTIONS = [
  new Section({
    id: '700WB115',
    name: '700 WB 115',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 692,
      bf: 250,
      tf: 16,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 14600,
      ix: 1150e6,
      iy: 4.17e+07,
      zx: 3330e3,
      zy: 334e3,
      sx: 3790e3,
      sy: 516e3,
      rx: 281,
      ry: 53.5,
      j: 888e3,
      iw: 4770e9,
      fy: 300,
      fyw: 310,
      fu: 440,
      kf: 0.767,
      compactnessX: 'C',
      zex: 3790,
      compactnessY: 'N',
      zey: 498
    }
  }),

  new Section({
    id: '700WB115_350',
    name: '700 WB 115',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 692,
      bf: 250,
      tf: 16,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 14600,
      ix: 1150e6,
      iy: 4.17e+07,
      zx: 3330e3,
      zy: 334e3,
      sx: 3790e3,
      sy: 516e3,
      rx: 281,
      ry: 53.5,
      j: 888e3,
      iw: 4770e9,
      fy: 380,
      fyw: 400,
      fu: 480,
      kf: 0.742,
      compactnessX: 'C',
      zex: 3790,
      compactnessY: 'N',
      zey: 486
    }
  }),

  new Section({
    id: '700WB130',
    name: '700 WB 130',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 700,
      bf: 250,
      tf: 20,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 16600,
      ix: 1400e6,
      iy: 5.21e+07,
      zx: 3990e3,
      zy: 417e3,
      sx: 4490e3,
      sy: 642e3,
      rx: 290,
      ry: 56,
      j: 1510e3,
      iw: 6030e9,
      fy: 300,
      fyw: 310,
      fu: 440,
      kf: 0.795,
      compactnessX: 'C',
      zex: 4490,
      compactnessY: 'C',
      zey: 626
    }
  }),

  new Section({
    id: '700WB130_350',
    name: '700 WB 130',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 700,
      bf: 250,
      tf: 20,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 16600,
      ix: 1400e6,
      iy: 5.21e+07,
      zx: 3990e3,
      zy: 417e3,
      sx: 4490e3,
      sy: 642e3,
      rx: 290,
      ry: 56,
      j: 1510e3,
      iw: 6030e9,
      fy: 380,
      fyw: 400,
      fu: 480,
      kf: 0.773,
      compactnessX: 'C',
      zex: 4490,
      compactnessY: 'C',
      zey: 626
    }
  }),

  new Section({
    id: '700WB150',
    name: '700 WB 150',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 710,
      bf: 250,
      tf: 25,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 19100,
      ix: 1710e6,
      iy: 6.52e+07,
      zx: 4810e3,
      zy: 521e3,
      sx: 5370e3,
      sy: 798e3,
      rx: 299,
      ry: 58.4,
      j: 2690e3,
      iw: 7640e9,
      fy: 280,
      fyw: 310,
      fu: 440,
      kf: 0.828,
      compactnessX: 'C',
      zex: 5370,
      compactnessY: 'C',
      zey: 782
    }
  }),

  new Section({
    id: '700WB150_350',
    name: '700 WB 150',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 710,
      bf: 250,
      tf: 25,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 19100,
      ix: 1710e6,
      iy: 6.52e+07,
      zx: 4810e3,
      zy: 521e3,
      sx: 5370e3,
      sy: 798e3,
      rx: 299,
      ry: 58.4,
      j: 2690e3,
      iw: 7640e9,
      fy: 360,
      fyw: 400,
      fu: 480,
      kf: 0.807,
      compactnessX: 'C',
      zex: 5370,
      compactnessY: 'C',
      zey: 782
    }
  }),

  new Section({
    id: '700WB173',
    name: '700 WB 173',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 716,
      bf: 275,
      tf: 28,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 22000,
      ix: 2060e6,
      iy: 9.71e+07,
      zx: 5760e3,
      zy: 706e3,
      sx: 6390e3,
      sy: 1080e3,
      rx: 306,
      ry: 66.4,
      j: 4020e3,
      iw: 11500e9,
      fy: 280,
      fyw: 310,
      fu: 440,
      kf: 0.85,
      compactnessX: 'C',
      zex: 6390,
      compactnessY: 'C',
      zey: 1060
    }
  }),

  new Section({
    id: '700WB173_350',
    name: '700 WB 173',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 716,
      bf: 275,
      tf: 28,
      tw: 10,
      r1: 0,
      d1: 660,
      ag: 22000,
      ix: 2060e6,
      iy: 9.71e+07,
      zx: 5760e3,
      zy: 706e3,
      sx: 6390e3,
      sy: 1080e3,
      rx: 306,
      ry: 66.4,
      j: 4020e3,
      iw: 11500e9,
      fy: 360,
      fyw: 400,
      fu: 480,
      kf: 0.833,
      compactnessX: 'C',
      zex: 6390,
      compactnessY: 'C',
      zey: 1060
    }
  }),

  new Section({
    id: '800WB122',
    name: '800 WB 122',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 792,
      bf: 250,
      tf: 16,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 15600,
      ix: 1570e6,
      iy: 4.17e+07,
      zx: 3970e3,
      zy: 334e3,
      sx: 4550e3,
      sy: 519e3,
      rx: 317,
      ry: 51.7,
      j: 921e3,
      iw: 6280e9,
      fy: 300,
      fyw: 310,
      fu: 440,
      kf: 0.718,
      compactnessX: 'N',
      zex: 4530,
      compactnessY: 'N',
      zey: 498
    }
  }),

  new Section({
    id: '800WB122_350',
    name: '800 WB 122',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 792,
      bf: 250,
      tf: 16,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 15600,
      ix: 1570e6,
      iy: 4.17e+07,
      zx: 3970e3,
      zy: 334e3,
      sx: 4550e3,
      sy: 519e3,
      rx: 317,
      ry: 51.7,
      j: 921e3,
      iw: 6280e9,
      fy: 380,
      fyw: 400,
      fu: 480,
      kf: 0.695,
      compactnessX: 'N',
      zex: 4340,
      compactnessY: 'N',
      zey: 486
    }
  }),

  new Section({
    id: '800WB146',
    name: '800 WB 146',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 800,
      bf: 275,
      tf: 20,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 18600,
      ix: 2040e6,
      iy: 6.94e+07,
      zx: 5100e3,
      zy: 505e3,
      sx: 5730e3,
      sy: 775e3,
      rx: 331,
      ry: 61.1,
      j: 1670e3,
      iw: 10600e9,
      fy: 300,
      fyw: 310,
      fu: 440,
      kf: 0.763,
      compactnessX: 'N',
      zex: 5710,
      compactnessY: 'C',
      zey: 757
    }
  }),

  new Section({
    id: '800WB146_350',
    name: '800 WB 146',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 800,
      bf: 275,
      tf: 20,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 18600,
      ix: 2040e6,
      iy: 6.94e+07,
      zx: 5100e3,
      zy: 505e3,
      sx: 5730e3,
      sy: 775e3,
      rx: 331,
      ry: 61.1,
      j: 1670e3,
      iw: 10600e9,
      fy: 380,
      fyw: 400,
      fu: 480,
      kf: 0.744,
      compactnessX: 'N',
      zex: 5510,
      compactnessY: 'N',
      zey: 754
    }
  }),

  new Section({
    id: '800WB168',
    name: '800 WB 168',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 810,
      bf: 275,
      tf: 25,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 21400,
      ix: 2480e6,
      iy: 8.67e+07,
      zx: 6140e3,
      zy: 631e3,
      sx: 6840e3,
      sy: 964e3,
      rx: 341,
      ry: 63.7,
      j: 2990e3,
      iw: 13400e9,
      fy: 280,
      fyw: 310,
      fu: 440,
      kf: 0.799,
      compactnessX: 'C',
      zex: 6840,
      compactnessY: 'C',
      zey: 946
    }
  }),

  new Section({
    id: '800WB168_350',
    name: '800 WB 168',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 810,
      bf: 275,
      tf: 25,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 21400,
      ix: 2480e6,
      iy: 8.67e+07,
      zx: 6140e3,
      zy: 631e3,
      sx: 6840e3,
      sy: 964e3,
      rx: 341,
      ry: 63.7,
      j: 2990e3,
      iw: 13400e9,
      fy: 360,
      fyw: 400,
      fu: 480,
      kf: 0.781,
      compactnessX: 'N',
      zex: 6640,
      compactnessY: 'C',
      zey: 946
    }
  }),

  new Section({
    id: '800WB192',
    name: '800 WB 192',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 816,
      bf: 300,
      tf: 28,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 24400,
      ix: 2970e6,
      iy: 126e6,
      zx: 7290e3,
      zy: 840e3,
      sx: 8060e3,
      sy: 1280e3,
      rx: 349,
      ry: 71.9,
      j: 4420e3,
      iw: 19600e9,
      fy: 280,
      fyw: 310,
      fu: 440,
      kf: 0.824,
      compactnessX: 'C',
      zex: 8060,
      compactnessY: 'C',
      zey: 1260
    }
  }),

  new Section({
    id: '800WB192_350',
    name: '800 WB 192',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 816,
      bf: 300,
      tf: 28,
      tw: 10,
      r1: 0,
      d1: 760,
      ag: 24400,
      ix: 2970e6,
      iy: 126e6,
      zx: 7290e3,
      zy: 840e3,
      sx: 8060e3,
      sy: 1280e3,
      rx: 349,
      ry: 71.9,
      j: 4420e3,
      iw: 19600e9,
      fy: 360,
      fyw: 400,
      fu: 480,
      kf: 0.808,
      compactnessX: 'N',
      zex: 7850,
      compactnessY: 'C',
      zey: 1260
    }
  }),

  new Section({
    id: '900WB175',
    name: '900 WB 175',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 900,
      bf: 300,
      tf: 20,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 22300,
      ix: 2960e6,
      iy: 9.01e+07,
      zx: 6580e3,
      zy: 601e3,
      sx: 7500e3,
      sy: 931e3,
      rx: 364,
      ry: 63.5,
      j: 2060e3,
      iw: 17400e9,
      fy: 300,
      fyw: 310,
      fu: 440,
      kf: 0.744,
      compactnessX: 'C',
      zex: 7500,
      compactnessY: 'C',
      zey: 901
    }
  }),

  new Section({
    id: '900WB175_350',
    name: '900 WB 175',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 900,
      bf: 300,
      tf: 20,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 22300,
      ix: 2960e6,
      iy: 9.01e+07,
      zx: 6580e3,
      zy: 601e3,
      sx: 7500e3,
      sy: 931e3,
      rx: 364,
      ry: 63.5,
      j: 2060e3,
      iw: 17400e9,
      fy: 380,
      fyw: 400,
      fu: 480,
      kf: 0.721,
      compactnessX: 'N',
      zex: 7320,
      compactnessY: 'N',
      zey: 882
    }
  }),

  new Section({
    id: '900WB218',
    name: '900 WB 218',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 910,
      bf: 350,
      tf: 25,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 27800,
      ix: 4060e6,
      iy: 179e6,
      zx: 8930e3,
      zy: 1020e3,
      sx: 9960e3,
      sy: 1560e3,
      rx: 382,
      ry: 80.2,
      j: 4020e3,
      iw: 35000e9,
      fy: 280,
      fyw: 310,
      fu: 440,
      kf: 0.8,
      compactnessX: 'C',
      zex: 9960,
      compactnessY: 'C',
      zey: 1530
    }
  }),

  new Section({
    id: '900WB218_350',
    name: '900 WB 218',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 910,
      bf: 350,
      tf: 25,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 27800,
      ix: 4060e6,
      iy: 179e6,
      zx: 8930e3,
      zy: 1020e3,
      sx: 9960e3,
      sy: 1560e3,
      rx: 382,
      ry: 80.2,
      j: 4020e3,
      iw: 35000e9,
      fy: 360,
      fyw: 400,
      fu: 480,
      kf: 0.78,
      compactnessX: 'N',
      zex: 9840,
      compactnessY: 'N',
      zey: 1530
    }
  }),

  new Section({
    id: '900WB257',
    name: '900 WB 257',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 916,
      bf: 400,
      tf: 28,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 32700,
      ix: 5050e6,
      iy: 299e6,
      zx: 11000e3,
      zy: 1490e3,
      sx: 12200e3,
      sy: 2270e3,
      rx: 393,
      ry: 95.6,
      j: 6150e3,
      iw: 58900e9,
      fy: 280,
      fyw: 310,
      fu: 440,
      kf: 0.83,
      compactnessX: 'C',
      zex: 12200,
      compactnessY: 'C',
      zey: 2240
    }
  }),

  new Section({
    id: '900WB257_350',
    name: '900 WB 257',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 916,
      bf: 400,
      tf: 28,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 32700,
      ix: 5050e6,
      iy: 299e6,
      zx: 11000e3,
      zy: 1490e3,
      sx: 12200e3,
      sy: 2270e3,
      rx: 393,
      ry: 95.6,
      j: 6150e3,
      iw: 58900e9,
      fy: 360,
      fyw: 400,
      fu: 480,
      kf: 0.813,
      compactnessX: 'N',
      zex: 12000,
      compactnessY: 'N',
      zey: 2220
    }
  }),

  new Section({
    id: '900WB282',
    name: '900 WB 282',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 924,
      bf: 400,
      tf: 32,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 35900,
      ix: 5730e6,
      iy: 341e6,
      zx: 12400e3,
      zy: 1710e3,
      sx: 13600e3,
      sy: 2590e3,
      rx: 399,
      ry: 97.5,
      j: 8870e3,
      iw: 67900e9,
      fy: 280,
      fyw: 310,
      fu: 440,
      kf: 0.845,
      compactnessX: 'C',
      zex: 13600,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '900WB282_350',
    name: '900 WB 282',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 924,
      bf: 400,
      tf: 32,
      tw: 12,
      r1: 0,
      d1: 860,
      ag: 35900,
      ix: 5730e6,
      iy: 341e6,
      zx: 12400e3,
      zy: 1710e3,
      sx: 13600e3,
      sy: 2590e3,
      rx: 399,
      ry: 97.5,
      j: 8870e3,
      iw: 67900e9,
      fy: 360,
      fyw: 400,
      fu: 480,
      kf: 0.83,
      compactnessX: 'N',
      zex: 13500,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '1000WB215',
    name: '1000 WB 215',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1000,
      bf: 300,
      tf: 20,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 27400,
      ix: 4060e6,
      iy: 9.03e+07,
      zx: 8120e3,
      zy: 602e3,
      sx: 9570e3,
      sy: 961e3,
      rx: 385,
      ry: 57.5,
      j: 2890e3,
      iw: 21700e9,
      fy: 300,
      fyw: 300,
      fu: 440,
      kf: 0.738,
      compactnessX: 'C',
      zex: 9570,
      compactnessY: 'C',
      zey: 903
    }
  }),

  new Section({
    id: '1000WB215_350',
    name: '1000 WB 215',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1000,
      bf: 300,
      tf: 20,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 27400,
      ix: 4060e6,
      iy: 9.03e+07,
      zx: 8120e3,
      zy: 602e3,
      sx: 9570e3,
      sy: 961e3,
      rx: 385,
      ry: 57.5,
      j: 2890e3,
      iw: 21700e9,
      fy: 380,
      fyw: 380,
      fu: 480,
      kf: 0.704,
      compactnessX: 'C',
      zex: 9570,
      compactnessY: 'N',
      zey: 887
    }
  }),

  new Section({
    id: '1000WB258',
    name: '1000 WB 258',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1010,
      bf: 350,
      tf: 25,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 32900,
      ix: 5430e6,
      iy: 179e6,
      zx: 10700e3,
      zy: 1020e3,
      sx: 12300e3,
      sy: 1590e3,
      rx: 406,
      ry: 73.8,
      j: 4870e3,
      iw: 43400e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.79,
      compactnessX: 'C',
      zex: 12300,
      compactnessY: 'C',
      zey: 1530
    }
  }),

  new Section({
    id: '1000WB258_350',
    name: '1000 WB 258',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1010,
      bf: 350,
      tf: 25,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 32900,
      ix: 5430e6,
      iy: 179e6,
      zx: 10700e3,
      zy: 1020e3,
      sx: 12300e3,
      sy: 1590e3,
      rx: 406,
      ry: 73.8,
      j: 4870e3,
      iw: 43400e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.76,
      compactnessX: 'C',
      zex: 12300,
      compactnessY: 'N',
      zey: 1530
    }
  }),

  new Section({
    id: '1000WB296',
    name: '1000 WB 296',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1016,
      bf: 400,
      tf: 28,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 37800,
      ix: 6650e6,
      iy: 299e6,
      zx: 13100e3,
      zy: 1490e3,
      sx: 14800e3,
      sy: 2300e3,
      rx: 420,
      ry: 89,
      j: 7010e3,
      iw: 73000e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.817,
      compactnessX: 'C',
      zex: 14800,
      compactnessY: 'C',
      zey: 2240
    }
  }),

  new Section({
    id: '1000WB296_350',
    name: '1000 WB 296',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1016,
      bf: 400,
      tf: 28,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 37800,
      ix: 6650e6,
      iy: 299e6,
      zx: 13100e3,
      zy: 1490e3,
      sx: 14800e3,
      sy: 2300e3,
      rx: 420,
      ry: 89,
      j: 7010e3,
      iw: 73000e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.791,
      compactnessX: 'C',
      zex: 14800,
      compactnessY: 'N',
      zey: 2230
    }
  }),

  new Section({
    id: '1000WB322',
    name: '1000 WB 322',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1024,
      bf: 400,
      tf: 32,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 41000,
      ix: 7480e6,
      iy: 342e6,
      zx: 14600e3,
      zy: 1710e3,
      sx: 16400e3,
      sy: 2620e3,
      rx: 427,
      ry: 91.3,
      j: 9740e3,
      iw: 84100e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.832,
      compactnessX: 'C',
      zex: 16400,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '1000WB322_350',
    name: '1000 WB 322',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1024,
      bf: 400,
      tf: 32,
      tw: 16,
      r1: 0,
      d1: 960,
      ag: 41000,
      ix: 7480e6,
      iy: 342e6,
      zx: 14600e3,
      zy: 1710e3,
      sx: 16400e3,
      sy: 2620e3,
      rx: 427,
      ry: 91.3,
      j: 9740e3,
      iw: 84100e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.807,
      compactnessX: 'C',
      zex: 16400,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '1200WB249',
    name: '1200 WB 249',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1170,
      bf: 275,
      tf: 25,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 31700,
      ix: 6380e6,
      iy: 87e6,
      zx: 10900e3,
      zy: 633e3,
      sx: 12900e3,
      sy: 1020e3,
      rx: 449,
      ry: 52.4,
      j: 4310e3,
      iw: 28500e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.701,
      compactnessX: 'C',
      zex: 12900,
      compactnessY: 'C',
      zey: 949
    }
  }),

  new Section({
    id: '1200WB249_350',
    name: '1200 WB 249',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1170,
      bf: 275,
      tf: 25,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 31700,
      ix: 6380e6,
      iy: 87e6,
      zx: 10900e3,
      zy: 633e3,
      sx: 12900e3,
      sy: 1020e3,
      rx: 449,
      ry: 52.4,
      j: 4310e3,
      iw: 28500e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.67,
      compactnessX: 'N',
      zex: 12800,
      compactnessY: 'C',
      zey: 949
    }
  }),

  new Section({
    id: '1200WB278',
    name: '1200 WB 278',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1170,
      bf: 350,
      tf: 25,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 35400,
      ix: 7610e6,
      iy: 179e6,
      zx: 13000e3,
      zy: 1020e3,
      sx: 15000e3,
      sy: 1600e3,
      rx: 464,
      ry: 71.1,
      j: 5090e3,
      iw: 58700e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.733,
      compactnessX: 'C',
      zex: 15000,
      compactnessY: 'C',
      zey: 1530
    }
  }),

  new Section({
    id: '1200WB278_350',
    name: '1200 WB 278',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1170,
      bf: 350,
      tf: 25,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 35400,
      ix: 7610e6,
      iy: 179e6,
      zx: 13000e3,
      zy: 1020e3,
      sx: 15000e3,
      sy: 1600e3,
      rx: 464,
      ry: 71.1,
      j: 5090e3,
      iw: 58700e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.705,
      compactnessX: 'N',
      zex: 14900,
      compactnessY: 'N',
      zey: 1530
    }
  }),

  new Section({
    id: '1200WB317',
    name: '1200 WB 317',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1176,
      bf: 400,
      tf: 28,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 40300,
      ix: 9250e6,
      iy: 299e6,
      zx: 15700e3,
      zy: 1500e3,
      sx: 17900e3,
      sy: 2310e3,
      rx: 479,
      ry: 86.1,
      j: 7230e3,
      iw: 98500e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.766,
      compactnessX: 'C',
      zex: 17900,
      compactnessY: 'C',
      zey: 2240
    }
  }),

  new Section({
    id: '1200WB317_350',
    name: '1200 WB 317',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1176,
      bf: 400,
      tf: 28,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 40300,
      ix: 9250e6,
      iy: 299e6,
      zx: 15700e3,
      zy: 1500e3,
      sx: 17900e3,
      sy: 2310e3,
      rx: 479,
      ry: 86.1,
      j: 7230e3,
      iw: 98500e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.741,
      compactnessX: 'N',
      zex: 17700,
      compactnessY: 'N',
      zey: 2230
    }
  }),

  new Section({
    id: '1200WB342',
    name: '1200 WB 342',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1184,
      bf: 400,
      tf: 32,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 43500,
      ix: 10400e6,
      iy: 342e6,
      zx: 17500e3,
      zy: 1710e3,
      sx: 19800e3,
      sy: 2630e3,
      rx: 488,
      ry: 88.6,
      j: 9960e3,
      iw: 113000e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.783,
      compactnessX: 'C',
      zex: 19800,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '1200WB342_350',
    name: '1200 WB 342',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1184,
      bf: 400,
      tf: 32,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 43500,
      ix: 10400e6,
      iy: 342e6,
      zx: 17500e3,
      zy: 1710e3,
      sx: 19800e3,
      sy: 2630e3,
      rx: 488,
      ry: 88.6,
      j: 9960e3,
      iw: 113000e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.76,
      compactnessX: 'N',
      zex: 19600,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '1200WB392',
    name: '1200 WB 392',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1184,
      bf: 500,
      tf: 32,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 49900,
      ix: 12500e6,
      iy: 667e6,
      zx: 21100e3,
      zy: 2670e3,
      sx: 23400e3,
      sy: 4070e3,
      rx: 500,
      ry: 116,
      j: 12100e3,
      iw: 221000e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.811,
      compactnessX: 'C',
      zex: 23400,
      compactnessY: 'N',
      zey: 4000
    }
  }),

  new Section({
    id: '1200WB392_350',
    name: '1200 WB 392',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1184,
      bf: 500,
      tf: 32,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 49900,
      ix: 12500e6,
      iy: 667e6,
      zx: 21100e3,
      zy: 2670e3,
      sx: 23400e3,
      sy: 4070e3,
      rx: 500,
      ry: 116,
      j: 12100e3,
      iw: 221000e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.791,
      compactnessX: 'N',
      zex: 23300,
      compactnessY: 'N',
      zey: 3900
    }
  }),

  new Section({
    id: '1200WB423',
    name: '1200 WB 423',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1192,
      bf: 500,
      tf: 36,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 53900,
      ix: 13900e6,
      iy: 750e6,
      zx: 23300e3,
      zy: 3000e3,
      sx: 25800e3,
      sy: 4570e3,
      rx: 508,
      ry: 118,
      j: 16500e3,
      iw: 251000e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.825,
      compactnessX: 'C',
      zex: 25800,
      compactnessY: 'C',
      zey: 4500
    }
  }),

  new Section({
    id: '1200WB423_350',
    name: '1200 WB 423',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1192,
      bf: 500,
      tf: 36,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 53900,
      ix: 13900e6,
      iy: 750e6,
      zx: 23300e3,
      zy: 3000e3,
      sx: 25800e3,
      sy: 4570e3,
      rx: 508,
      ry: 118,
      j: 16500e3,
      iw: 251000e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.806,
      compactnessX: 'N',
      zex: 25700,
      compactnessY: 'N',
      zey: 4500
    }
  }),

  new Section({
    id: '1200WB455',
    name: '1200 WB 455',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1200,
      bf: 500,
      tf: 40,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 57900,
      ix: 15300e6,
      iy: 834e6,
      zx: 25600e3,
      zy: 3330e3,
      sx: 28200e3,
      sy: 5070e3,
      rx: 515,
      ry: 120,
      j: 22000e3,
      iw: 280000e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.837,
      compactnessX: 'C',
      zex: 28200,
      compactnessY: 'C',
      zey: 5000
    }
  }),

  new Section({
    id: '1200WB455_350',
    name: '1200 WB 455',
    category: SECTION_CATEGORIES.WELDED_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 1200,
      bf: 500,
      tf: 40,
      tw: 16,
      r1: 0,
      d1: 1120,
      ag: 57900,
      ix: 15300e6,
      iy: 834e6,
      zx: 25600e3,
      zy: 3330e3,
      sx: 28200e3,
      sy: 5070e3,
      rx: 515,
      ry: 120,
      j: 22000e3,
      iw: 280000e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 0.82,
      compactnessX: 'N',
      zex: 28100,
      compactnessY: 'C',
      zey: 5000
    }
  }),

  new Section({
    id: '350WC197',
    name: '350 WC 197',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 331,
      bf: 350,
      tf: 28,
      tw: 20,
      r1: 0,
      d1: 275,
      ag: 25100,
      ix: 486e6,
      iy: 200e6,
      zx: 2940e3,
      zy: 1140e3,
      sx: 3350e3,
      sy: 1740e3,
      rx: 139,
      ry: 89.3,
      j: 5750e3,
      iw: 4600e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 3350,
      compactnessY: 'C',
      zey: 1720
    }
  }),

  new Section({
    id: '350WC197_350',
    name: '350 WC 197',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 331,
      bf: 350,
      tf: 28,
      tw: 20,
      r1: 0,
      d1: 275,
      ag: 25100,
      ix: 486e6,
      iy: 200e6,
      zx: 2940e3,
      zy: 1140e3,
      sx: 3350e3,
      sy: 1740e3,
      rx: 139,
      ry: 89.3,
      j: 5750e3,
      iw: 4600e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 3350,
      compactnessY: 'C',
      zey: 1720
    }
  }),

  new Section({
    id: '350WC230',
    name: '350 WC 230',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 339,
      bf: 350,
      tf: 32,
      tw: 25,
      r1: 0,
      d1: 275,
      ag: 29300,
      ix: 573e6,
      iy: 229e6,
      zx: 3380e3,
      zy: 1310e3,
      sx: 3910e3,
      sy: 2000e3,
      rx: 140,
      ry: 88.4,
      j: 8960e3,
      iw: 5400e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 3910,
      compactnessY: 'C',
      zey: 1960
    }
  }),

  new Section({
    id: '350WC230_350',
    name: '350 WC 230',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 339,
      bf: 350,
      tf: 32,
      tw: 25,
      r1: 0,
      d1: 275,
      ag: 29300,
      ix: 573e6,
      iy: 229e6,
      zx: 3380e3,
      zy: 1310e3,
      sx: 3910e3,
      sy: 2000e3,
      rx: 140,
      ry: 88.4,
      j: 8960e3,
      iw: 5400e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 3910,
      compactnessY: 'C',
      zey: 1960
    }
  }),

  new Section({
    id: '350WC258',
    name: '350 WC 258',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 347,
      bf: 350,
      tf: 36,
      tw: 28,
      r1: 0,
      d1: 275,
      ag: 32900,
      ix: 661e6,
      iy: 258e6,
      zx: 3810e3,
      zy: 1470e3,
      sx: 4450e3,
      sy: 2260e3,
      rx: 142,
      ry: 88.5,
      j: 12700e3,
      iw: 6230e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 4450,
      compactnessY: 'C',
      zey: 2210
    }
  }),

  new Section({
    id: '350WC258_350',
    name: '350 WC 258',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 347,
      bf: 350,
      tf: 36,
      tw: 28,
      r1: 0,
      d1: 275,
      ag: 32900,
      ix: 661e6,
      iy: 258e6,
      zx: 3810e3,
      zy: 1470e3,
      sx: 4450e3,
      sy: 2260e3,
      rx: 142,
      ry: 88.5,
      j: 12700e3,
      iw: 6230e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 4450,
      compactnessY: 'C',
      zey: 2210
    }
  }),

  new Section({
    id: '350WC280',
    name: '350 WC 280',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 355,
      bf: 350,
      tf: 40,
      tw: 28,
      r1: 0,
      d1: 275,
      ag: 35700,
      ix: 747e6,
      iy: 286e6,
      zx: 4210e3,
      zy: 1640e3,
      sx: 4940e3,
      sy: 2500e3,
      rx: 145,
      ry: 89.6,
      j: 16500e3,
      iw: 7100e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 4940,
      compactnessY: 'C',
      zey: 2450
    }
  }),

  new Section({
    id: '350WC280_350',
    name: '350 WC 280',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 355,
      bf: 350,
      tf: 40,
      tw: 28,
      r1: 0,
      d1: 275,
      ag: 35700,
      ix: 747e6,
      iy: 286e6,
      zx: 4210e3,
      zy: 1640e3,
      sx: 4940e3,
      sy: 2500e3,
      rx: 145,
      ry: 89.6,
      j: 16500e3,
      iw: 7100e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 4940,
      compactnessY: 'C',
      zey: 2450
    }
  }),

  new Section({
    id: '400WC144',
    name: '400 WC 144',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 382,
      bf: 400,
      tf: 16,
      tw: 16,
      r1: 0,
      d1: 350,
      ag: 18400,
      ix: 486e6,
      iy: 171e6,
      zx: 2550e3,
      zy: 854e3,
      sx: 2830e3,
      sy: 1300e3,
      rx: 163,
      ry: 96.3,
      j: 1580e3,
      iw: 5720e9,
      fy: 300,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 2590,
      compactnessY: 'N',
      zey: 1120
    }
  }),

  new Section({
    id: '400WC144_350',
    name: '400 WC 144',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 382,
      bf: 400,
      tf: 16,
      tw: 16,
      r1: 0,
      d1: 350,
      ag: 18400,
      ix: 486e6,
      iy: 171e6,
      zx: 2550e3,
      zy: 854e3,
      sx: 2830e3,
      sy: 1300e3,
      rx: 163,
      ry: 96.3,
      j: 1580e3,
      iw: 5720e9,
      fy: 380,
      fyw: 380,
      fu: 480,
      kf: 0.964,
      compactnessX: 'S',
      zex: 2440,
      compactnessY: 'N',
      zey: 1070
    }
  }),

  new Section({
    id: '400WC181',
    name: '400 WC 181',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 390,
      bf: 400,
      tf: 20,
      tw: 20,
      r1: 0,
      d1: 350,
      ag: 23000,
      ix: 620e6,
      iy: 214e6,
      zx: 3180e3,
      zy: 1070e3,
      sx: 3570e3,
      sy: 1640e3,
      rx: 164,
      ry: 96.4,
      j: 3080e3,
      iw: 7310e9,
      fy: 300,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 3410,
      compactnessY: 'N',
      zey: 1510
    }
  }),

  new Section({
    id: '400WC181_350',
    name: '400 WC 181',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 390,
      bf: 400,
      tf: 20,
      tw: 20,
      r1: 0,
      d1: 350,
      ag: 23000,
      ix: 620e6,
      iy: 214e6,
      zx: 3180e3,
      zy: 1070e3,
      sx: 3570e3,
      sy: 1640e3,
      rx: 164,
      ry: 96.4,
      j: 3080e3,
      iw: 7310e9,
      fy: 380,
      fyw: 380,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 3330,
      compactnessY: 'N',
      zey: 1460
    }
  }),

  new Section({
    id: '400WC212',
    name: '400 WC 212',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 400,
      bf: 400,
      tf: 25,
      tw: 20,
      r1: 0,
      d1: 350,
      ag: 27000,
      ix: 776e6,
      iy: 267e6,
      zx: 3880e3,
      zy: 1330e3,
      sx: 4360e3,
      sy: 2040e3,
      rx: 169,
      ry: 99.4,
      j: 5060e3,
      iw: 9380e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 4360,
      compactnessY: 'N',
      zey: 2000
    }
  }),

  new Section({
    id: '400WC212_350',
    name: '400 WC 212',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 400,
      bf: 400,
      tf: 25,
      tw: 20,
      r1: 0,
      d1: 350,
      ag: 27000,
      ix: 776e6,
      iy: 267e6,
      zx: 3880e3,
      zy: 1330e3,
      sx: 4360e3,
      sy: 2040e3,
      rx: 169,
      ry: 99.4,
      j: 5060e3,
      iw: 9380e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 4270,
      compactnessY: 'N',
      zey: 1950
    }
  }),

  new Section({
    id: '400WC270',
    name: '400 WC 270',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 414,
      bf: 400,
      tf: 32,
      tw: 25,
      r1: 0,
      d1: 350,
      ag: 34400,
      ix: 1030e6,
      iy: 342e6,
      zx: 4950e3,
      zy: 1710e3,
      sx: 5660e3,
      sy: 2610e3,
      rx: 173,
      ry: 99.8,
      j: 10400e3,
      iw: 12500e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 5660,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '400WC270_350',
    name: '400 WC 270',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 414,
      bf: 400,
      tf: 32,
      tw: 25,
      r1: 0,
      d1: 350,
      ag: 34400,
      ix: 1030e6,
      iy: 342e6,
      zx: 4950e3,
      zy: 1710e3,
      sx: 5660e3,
      sy: 2610e3,
      rx: 173,
      ry: 99.8,
      j: 10400e3,
      iw: 12500e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 5660,
      compactnessY: 'C',
      zey: 2560
    }
  }),

  new Section({
    id: '400WC303',
    name: '400 WC 303',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 422,
      bf: 400,
      tf: 36,
      tw: 28,
      r1: 0,
      d1: 350,
      ag: 38600,
      ix: 1180e6,
      iy: 385e6,
      zx: 5570e3,
      zy: 1920e3,
      sx: 6420e3,
      sy: 2950e3,
      rx: 175,
      ry: 99.8,
      j: 14800e3,
      iw: 14300e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 6420,
      compactnessY: 'C',
      zey: 2880
    }
  }),

  new Section({
    id: '400WC303_350',
    name: '400 WC 303',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 422,
      bf: 400,
      tf: 36,
      tw: 28,
      r1: 0,
      d1: 350,
      ag: 38600,
      ix: 1180e6,
      iy: 385e6,
      zx: 5570e3,
      zy: 1920e3,
      sx: 6420e3,
      sy: 2950e3,
      rx: 175,
      ry: 99.8,
      j: 14800e3,
      iw: 14300e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 6420,
      compactnessY: 'C',
      zey: 2880
    }
  }),

  new Section({
    id: '400WC328',
    name: '400 WC 328',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 430,
      bf: 400,
      tf: 40,
      tw: 28,
      r1: 0,
      d1: 350,
      ag: 41800,
      ix: 1320e6,
      iy: 427e6,
      zx: 6140e3,
      zy: 2140e3,
      sx: 7100e3,
      sy: 3270e3,
      rx: 178,
      ry: 101,
      j: 19200e3,
      iw: 16200e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 7100,
      compactnessY: 'C',
      zey: 3200
    }
  }),

  new Section({
    id: '400WC328_350',
    name: '400 WC 328',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 430,
      bf: 400,
      tf: 40,
      tw: 28,
      r1: 0,
      d1: 350,
      ag: 41800,
      ix: 1320e6,
      iy: 427e6,
      zx: 6140e3,
      zy: 2140e3,
      sx: 7100e3,
      sy: 3270e3,
      rx: 178,
      ry: 101,
      j: 19200e3,
      iw: 16200e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 7100,
      compactnessY: 'C',
      zey: 3200
    }
  }),

  new Section({
    id: '400WC361',
    name: '400 WC 361',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 430,
      bf: 400,
      tf: 40,
      tw: 40,
      r1: 0,
      d1: 350,
      ag: 46000,
      ix: 1360e6,
      iy: 429e6,
      zx: 6340e3,
      zy: 2140e3,
      sx: 7460e3,
      sy: 3340e3,
      rx: 172,
      ry: 96.5,
      j: 24800e3,
      iw: 16300e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 7470,
      compactnessY: 'C',
      zey: 3210
    }
  }),

  new Section({
    id: '400WC361_350',
    name: '400 WC 361',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 430,
      bf: 400,
      tf: 40,
      tw: 40,
      r1: 0,
      d1: 350,
      ag: 46000,
      ix: 1360e6,
      iy: 429e6,
      zx: 6340e3,
      zy: 2140e3,
      sx: 7460e3,
      sy: 3340e3,
      rx: 172,
      ry: 96.5,
      j: 24800e3,
      iw: 16300e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 7470,
      compactnessY: 'C',
      zey: 3210
    }
  }),

  new Section({
    id: '500WC228',
    name: '500 WC 228',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 490,
      bf: 500,
      tf: 20,
      tw: 20,
      r1: 0,
      d1: 450,
      ag: 29000,
      ix: 1260e6,
      iy: 417e6,
      zx: 5130e3,
      zy: 1670e3,
      sx: 5710e3,
      sy: 2540e3,
      rx: 208,
      ry: 120,
      j: 3880e3,
      iw: 23000e9,
      fy: 300,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 5210,
      compactnessY: 'N',
      zey: 2200
    }
  }),

  new Section({
    id: '500WC228_350',
    name: '500 WC 228',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 490,
      bf: 500,
      tf: 20,
      tw: 20,
      r1: 0,
      d1: 450,
      ag: 29000,
      ix: 1260e6,
      iy: 417e6,
      zx: 5130e3,
      zy: 1670e3,
      sx: 5710e3,
      sy: 2540e3,
      rx: 208,
      ry: 120,
      j: 3880e3,
      iw: 23000e9,
      fy: 380,
      fyw: 380,
      fu: 480,
      kf: 0.964,
      compactnessX: 'S',
      zex: 4920,
      compactnessY: 'N',
      zey: 2100
    }
  }),

  new Section({
    id: '500WC267',
    name: '500 WC 267',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 500,
      bf: 500,
      tf: 25,
      tw: 20,
      r1: 0,
      d1: 450,
      ag: 34000,
      ix: 1560e6,
      iy: 521e6,
      zx: 6250e3,
      zy: 2080e3,
      sx: 6950e3,
      sy: 3170e3,
      rx: 214,
      ry: 124,
      j: 6370e3,
      iw: 29400e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 6700,
      compactnessY: 'N',
      zey: 2970
    }
  }),

  new Section({
    id: '500WC267_350',
    name: '500 WC 267',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 500,
      bf: 500,
      tf: 25,
      tw: 20,
      r1: 0,
      d1: 450,
      ag: 34000,
      ix: 1560e6,
      iy: 521e6,
      zx: 6250e3,
      zy: 2080e3,
      sx: 6950e3,
      sy: 3170e3,
      rx: 214,
      ry: 124,
      j: 6370e3,
      iw: 29400e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 6540,
      compactnessY: 'N',
      zey: 2860
    }
  }),

  new Section({
    id: '500WC290',
    name: '500 WC 290',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 506,
      bf: 500,
      tf: 28,
      tw: 20,
      r1: 0,
      d1: 450,
      ag: 37000,
      ix: 1750e6,
      iy: 584e6,
      zx: 6930e3,
      zy: 2330e3,
      sx: 7700e3,
      sy: 3540e3,
      rx: 218,
      ry: 126,
      j: 8420e3,
      iw: 33300e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 7570,
      compactnessY: 'N',
      zey: 3410
    }
  }),

  new Section({
    id: '500WC290_350',
    name: '500 WC 290',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 506,
      bf: 500,
      tf: 28,
      tw: 20,
      r1: 0,
      d1: 450,
      ag: 37000,
      ix: 1750e6,
      iy: 584e6,
      zx: 6930e3,
      zy: 2330e3,
      sx: 7700e3,
      sy: 3540e3,
      rx: 218,
      ry: 126,
      j: 8420e3,
      iw: 33300e9,
      fy: 360,
      fyw: 380,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 7410,
      compactnessY: 'N',
      zey: 3310
    }
  }),

  new Section({
    id: '500WC340',
    name: '500 WC 340',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 514,
      bf: 500,
      tf: 32,
      tw: 25,
      r1: 0,
      d1: 450,
      ag: 43200,
      ix: 2050e6,
      iy: 667e6,
      zx: 7980e3,
      zy: 2670e3,
      sx: 8980e3,
      sy: 4070e3,
      rx: 218,
      ry: 124,
      j: 13100e3,
      iw: 38800e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 8980,
      compactnessY: 'C',
      zey: 4000
    }
  }),

  new Section({
    id: '500WC340_350',
    name: '500 WC 340',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 514,
      bf: 500,
      tf: 32,
      tw: 25,
      r1: 0,
      d1: 450,
      ag: 43200,
      ix: 2050e6,
      iy: 667e6,
      zx: 7980e3,
      zy: 2670e3,
      sx: 8980e3,
      sy: 4070e3,
      rx: 218,
      ry: 124,
      j: 13100e3,
      iw: 38800e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 8830,
      compactnessY: 'N',
      zey: 3920
    }
  }),

  new Section({
    id: '500WC383',
    name: '500 WC 383',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 472,
      bf: 500,
      tf: 36,
      tw: 32,
      r1: 0,
      d1: 400,
      ag: 48800,
      ix: 1890e6,
      iy: 751e6,
      zx: 7990e3,
      zy: 3000e3,
      sx: 9130e3,
      sy: 4600e3,
      rx: 197,
      ry: 124,
      j: 19900e3,
      iw: 35700e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 9130,
      compactnessY: 'C',
      zey: 4510
    }
  }),

  new Section({
    id: '500WC383_350',
    name: '500 WC 383',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 472,
      bf: 500,
      tf: 36,
      tw: 32,
      r1: 0,
      d1: 400,
      ag: 48800,
      ix: 1890e6,
      iy: 751e6,
      zx: 7990e3,
      zy: 3000e3,
      sx: 9130e3,
      sy: 4600e3,
      rx: 197,
      ry: 124,
      j: 19900e3,
      iw: 35700e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 9130,
      compactnessY: 'C',
      zey: 4510
    }
  }),

  new Section({
    id: '500WC414',
    name: '500 WC 414',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 480,
      bf: 500,
      tf: 40,
      tw: 32,
      r1: 0,
      d1: 400,
      ag: 52800,
      ix: 2110e6,
      iy: 834e6,
      zx: 8800e3,
      zy: 3340e3,
      sx: 10100e3,
      sy: 5100e3,
      rx: 200,
      ry: 126,
      j: 25400e3,
      iw: 40400e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 10100,
      compactnessY: 'C',
      zey: 5010
    }
  }),

  new Section({
    id: '500WC414_350',
    name: '500 WC 414',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 480,
      bf: 500,
      tf: 40,
      tw: 32,
      r1: 0,
      d1: 400,
      ag: 52800,
      ix: 2110e6,
      iy: 834e6,
      zx: 8800e3,
      zy: 3340e3,
      sx: 10100e3,
      sy: 5100e3,
      rx: 200,
      ry: 126,
      j: 25400e3,
      iw: 40400e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 10100,
      compactnessY: 'C',
      zey: 5010
    }
  }),

  new Section({
    id: '500WC440',
    name: '500 WC 440',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 480,
      bf: 500,
      tf: 40,
      tw: 40,
      r1: 0,
      d1: 400,
      ag: 56000,
      ix: 2150e6,
      iy: 835e6,
      zx: 8980e3,
      zy: 3340e3,
      sx: 10400e3,
      sy: 5160e3,
      rx: 196,
      ry: 122,
      j: 30100e3,
      iw: 40400e9,
      fy: 280,
      fyw: 280,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 10400,
      compactnessY: 'C',
      zey: 5010
    }
  }),

  new Section({
    id: '500WC440_350',
    name: '500 WC 440',
    category: SECTION_CATEGORIES.WELDED_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Welded',
      availability: 'Common',
      d: 480,
      bf: 500,
      tf: 40,
      tw: 40,
      r1: 0,
      d1: 400,
      ag: 56000,
      ix: 2150e6,
      iy: 835e6,
      zx: 8980e3,
      zy: 3340e3,
      sx: 10400e3,
      sy: 5160e3,
      rx: 196,
      ry: 122,
      j: 30100e3,
      iw: 40400e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 10400,
      compactnessY: 'C',
      zey: 5010
    }
  }),

  new Section({
    id: '150UB14.0_300',
    name: '150 UB 14.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 150,
      bf: 75,
      tf: 7,
      tw: 5,
      r1: 8,
      d1: 136,
      ag: 1780,
      ix: 6.66e+06,
      iy: 495000,
      zx: 88800,
      zy: 13200,
      sx: 102e3,
      sy: 20800,
      rx: 61.1,
      ry: 16.6,
      j: 28100,
      iw: 2.53e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 102,
      compactnessY: 'C',
      zey: 19.8
    }
  }),

  new Section({
    id: '150UB14.0_350',
    name: '150 UB 14.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 150,
      bf: 75,
      tf: 7,
      tw: 5,
      r1: 8,
      d1: 136,
      ag: 1780,
      ix: 6.66e+06,
      iy: 495000,
      zx: 88800,
      zy: 13200,
      sx: 102e3,
      sy: 20800,
      rx: 61.1,
      ry: 16.6,
      j: 28100,
      iw: 2.53e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 102,
      compactnessY: 'C',
      zey: 19.8
    }
  }),

  new Section({
    id: '150UB18.0_300',
    name: '150 UB 18.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 155,
      bf: 75,
      tf: 9.5,
      tw: 6,
      r1: 8,
      d1: 136,
      ag: 2300,
      ix: 9.05e+06,
      iy: 672000,
      zx: 117e3,
      zy: 17900,
      sx: 135e3,
      sy: 28200,
      rx: 62.8,
      ry: 17.1,
      j: 60500,
      iw: 3.56e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 135,
      compactnessY: 'C',
      zey: 26.9
    }
  }),

  new Section({
    id: '150UB18.0_350',
    name: '150 UB 18.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 155,
      bf: 75,
      tf: 9.5,
      tw: 6,
      r1: 8,
      d1: 136,
      ag: 2300,
      ix: 9.05e+06,
      iy: 672000,
      zx: 117e3,
      zy: 17900,
      sx: 135e3,
      sy: 28200,
      rx: 62.8,
      ry: 17.1,
      j: 60500,
      iw: 3.56e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 135,
      compactnessY: 'C',
      zey: 26.9
    }
  }),

  new Section({
    id: '180UB16.1_300',
    name: '180 UB 16.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 173,
      bf: 90,
      tf: 7,
      tw: 4.5,
      r1: 8.9,
      d1: 159,
      ag: 2040,
      ix: 1.06e+07,
      iy: 853000,
      zx: 123e3,
      zy: 19e3,
      sx: 138e3,
      sy: 29400,
      rx: 72,
      ry: 20.4,
      j: 31500,
      iw: 5.88e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 138,
      compactnessY: 'C',
      zey: 28.4
    }
  }),

  new Section({
    id: '180UB16.1_350',
    name: '180 UB 16.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 173,
      bf: 90,
      tf: 7,
      tw: 4.5,
      r1: 8.9,
      d1: 159,
      ag: 2040,
      ix: 1.06e+07,
      iy: 853000,
      zx: 123e3,
      zy: 19e3,
      sx: 138e3,
      sy: 29400,
      rx: 72,
      ry: 20.4,
      j: 31500,
      iw: 5.88e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 138,
      compactnessY: 'C',
      zey: 28.4
    }
  }),

  new Section({
    id: '180UB18.1_300',
    name: '180 UB 18.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 175,
      bf: 90,
      tf: 8,
      tw: 5,
      r1: 8.9,
      d1: 159,
      ag: 2300,
      ix: 1.21e+07,
      iy: 975000,
      zx: 139e3,
      zy: 21700,
      sx: 157e3,
      sy: 33700,
      rx: 72.6,
      ry: 20.6,
      j: 44800,
      iw: 6.8e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 157,
      compactnessY: 'C',
      zey: 32.5
    }
  }),

  new Section({
    id: '180UB18.1_350',
    name: '180 UB 18.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 175,
      bf: 90,
      tf: 8,
      tw: 5,
      r1: 8.9,
      d1: 159,
      ag: 2300,
      ix: 1.21e+07,
      iy: 975000,
      zx: 139e3,
      zy: 21700,
      sx: 157e3,
      sy: 33700,
      rx: 72.6,
      ry: 20.6,
      j: 44800,
      iw: 6.8e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 157,
      compactnessY: 'C',
      zey: 32.5
    }
  }),

  new Section({
    id: '180UB22.2_300',
    name: '180 UB 22.2',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 179,
      bf: 90,
      tf: 10,
      tw: 6,
      r1: 8.9,
      d1: 159,
      ag: 2820,
      ix: 1.53e+07,
      iy: 1.22e+06,
      zx: 171e3,
      zy: 27100,
      sx: 195e3,
      sy: 42300,
      rx: 73.6,
      ry: 20.8,
      j: 81600,
      iw: 8.71e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 195,
      compactnessY: 'C',
      zey: 40.7
    }
  }),

  new Section({
    id: '180UB22.2_350',
    name: '180 UB 22.2',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 179,
      bf: 90,
      tf: 10,
      tw: 6,
      r1: 8.9,
      d1: 159,
      ag: 2820,
      ix: 1.53e+07,
      iy: 1.22e+06,
      zx: 171e3,
      zy: 27100,
      sx: 195e3,
      sy: 42300,
      rx: 73.6,
      ry: 20.8,
      j: 81600,
      iw: 8.71e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 195,
      compactnessY: 'C',
      zey: 40.7
    }
  }),

  new Section({
    id: '200UB18.2_300',
    name: '200 UB 18.2',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 198,
      bf: 99,
      tf: 7,
      tw: 4.5,
      r1: 11,
      d1: 184,
      ag: 2320,
      ix: 1.58e+07,
      iy: 1.14e+06,
      zx: 160e3,
      zy: 23e3,
      sx: 180e3,
      sy: 35700,
      rx: 82.6,
      ry: 22.1,
      j: 38600,
      iw: 1.04e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 0.99,
      compactnessX: 'C',
      zex: 180,
      compactnessY: 'C',
      zey: 34.4
    }
  }),

  new Section({
    id: '200UB18.2_350',
    name: '200 UB 18.2',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 198,
      bf: 99,
      tf: 7,
      tw: 4.5,
      r1: 11,
      d1: 184,
      ag: 2320,
      ix: 1.58e+07,
      iy: 1.14e+06,
      zx: 160e3,
      zy: 23e3,
      sx: 180e3,
      sy: 35700,
      rx: 82.6,
      ry: 22.1,
      j: 38600,
      iw: 1.04e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 0.97,
      compactnessX: 'C',
      zex: 180,
      compactnessY: 'C',
      zey: 34.4
    }
  }),

  new Section({
    id: '200UB22.3_300',
    name: '200 UB 22.3',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 202,
      bf: 133,
      tf: 7,
      tw: 5,
      r1: 8.9,
      d1: 188,
      ag: 2870,
      ix: 21e6,
      iy: 2.75e+06,
      zx: 208e3,
      zy: 41300,
      sx: 231e3,
      sy: 63400,
      rx: 85.5,
      ry: 31,
      j: 45e3,
      iw: 26e9,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 227,
      compactnessY: 'N',
      zey: 60.3
    }
  }),

  new Section({
    id: '200UB22.3_350',
    name: '200 UB 22.3',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 202,
      bf: 133,
      tf: 7,
      tw: 5,
      r1: 8.9,
      d1: 188,
      ag: 2870,
      ix: 21e6,
      iy: 2.75e+06,
      zx: 208e3,
      zy: 41300,
      sx: 231e3,
      sy: 63400,
      rx: 85.5,
      ry: 31,
      j: 45e3,
      iw: 26e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 225,
      compactnessY: 'N',
      zey: 59.4
    }
  }),

  new Section({
    id: '200UB25.4_300',
    name: '200 UB 25.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 203,
      bf: 133,
      tf: 7.8,
      tw: 5.8,
      r1: 8.9,
      d1: 188,
      ag: 3230,
      ix: 2.36e+07,
      iy: 3.06e+06,
      zx: 232e3,
      zy: 46100,
      sx: 260e3,
      sy: 70900,
      rx: 85.4,
      ry: 30.8,
      j: 62700,
      iw: 2.92e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 259,
      compactnessY: 'N',
      zey: 68.8
    }
  }),

  new Section({
    id: '200UB25.4_350',
    name: '200 UB 25.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 203,
      bf: 133,
      tf: 7.8,
      tw: 5.8,
      r1: 8.9,
      d1: 188,
      ag: 3230,
      ix: 2.36e+07,
      iy: 3.06e+06,
      zx: 232e3,
      zy: 46100,
      sx: 260e3,
      sy: 70900,
      rx: 85.4,
      ry: 30.8,
      j: 62700,
      iw: 2.92e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 257,
      compactnessY: 'N',
      zey: 68
    }
  }),

  new Section({
    id: '200UB29.8_300',
    name: '200 UB 29.8',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 207,
      bf: 134,
      tf: 9.6,
      tw: 6.3,
      r1: 8.9,
      d1: 188,
      ag: 3820,
      ix: 2.91e+07,
      iy: 3.86e+06,
      zx: 281e3,
      zy: 57500,
      sx: 316e3,
      sy: 88400,
      rx: 87.3,
      ry: 31.8,
      j: 105e3,
      iw: 3.76e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 316,
      compactnessY: 'C',
      zey: 86.3
    }
  }),

  new Section({
    id: '200UB29.8_350',
    name: '200 UB 29.8',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 207,
      bf: 134,
      tf: 9.6,
      tw: 6.3,
      r1: 8.9,
      d1: 188,
      ag: 3820,
      ix: 2.91e+07,
      iy: 3.86e+06,
      zx: 281e3,
      zy: 57500,
      sx: 316e3,
      sy: 88400,
      rx: 87.3,
      ry: 31.8,
      j: 105e3,
      iw: 3.76e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 316,
      compactnessY: 'C',
      zey: 86.3
    }
  }),

  new Section({
    id: '250UB25.7_300',
    name: '250 UB 25.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 248,
      bf: 124,
      tf: 8,
      tw: 5,
      r1: 12,
      d1: 232,
      ag: 3270,
      ix: 3.54e+07,
      iy: 2.55e+06,
      zx: 285e3,
      zy: 41100,
      sx: 319e3,
      sy: 63600,
      rx: 104,
      ry: 27.9,
      j: 67400,
      iw: 3.67e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 0.949,
      compactnessX: 'C',
      zex: 319,
      compactnessY: 'C',
      zey: 61.7
    }
  }),

  new Section({
    id: '250UB25.7_350',
    name: '250 UB 25.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 248,
      bf: 124,
      tf: 8,
      tw: 5,
      r1: 12,
      d1: 232,
      ag: 3270,
      ix: 3.54e+07,
      iy: 2.55e+06,
      zx: 285e3,
      zy: 41100,
      sx: 319e3,
      sy: 63600,
      rx: 104,
      ry: 27.9,
      j: 67400,
      iw: 3.67e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 0.932,
      compactnessX: 'C',
      zex: 319,
      compactnessY: 'C',
      zey: 61.7
    }
  }),

  new Section({
    id: '250UB31.4_300',
    name: '250 UB 31.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 252,
      bf: 146,
      tf: 8.6,
      tw: 6.1,
      r1: 8.9,
      d1: 234,
      ag: 4010,
      ix: 4.45e+07,
      iy: 4.47e+06,
      zx: 354e3,
      zy: 61200,
      sx: 397e3,
      sy: 94200,
      rx: 105,
      ry: 33.4,
      j: 89300,
      iw: 6.59e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 395,
      compactnessY: 'N',
      zey: 91.4
    }
  }),

  new Section({
    id: '250UB31.4_350',
    name: '250 UB 31.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 252,
      bf: 146,
      tf: 8.6,
      tw: 6.1,
      r1: 8.9,
      d1: 234,
      ag: 4010,
      ix: 4.45e+07,
      iy: 4.47e+06,
      zx: 354e3,
      zy: 61200,
      sx: 397e3,
      sy: 94200,
      rx: 105,
      ry: 33.4,
      j: 89300,
      iw: 6.59e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 0.991,
      compactnessX: 'N',
      zex: 392,
      compactnessY: 'N',
      zey: 90.3
    }
  }),

  new Section({
    id: '250UB37.3_300',
    name: '250 UB 37.3',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 256,
      bf: 146,
      tf: 10.9,
      tw: 6.4,
      r1: 8.9,
      d1: 234,
      ag: 4750,
      ix: 5.57e+07,
      iy: 5.66e+06,
      zx: 435e3,
      zy: 77500,
      sx: 486e3,
      sy: 119e3,
      rx: 108,
      ry: 34.5,
      j: 158e3,
      iw: 8.52e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 486,
      compactnessY: 'C',
      zey: 116
    }
  }),

  new Section({
    id: '250UB37.3_350',
    name: '250 UB 37.3',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 256,
      bf: 146,
      tf: 10.9,
      tw: 6.4,
      r1: 8.9,
      d1: 234,
      ag: 4750,
      ix: 5.57e+07,
      iy: 5.66e+06,
      zx: 435e3,
      zy: 77500,
      sx: 486e3,
      sy: 119e3,
      rx: 108,
      ry: 34.5,
      j: 158e3,
      iw: 8.52e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 486,
      compactnessY: 'C',
      zey: 116
    }
  }),

  new Section({
    id: '360UB32.0_300',
    name: '360 UB 32.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 298,
      bf: 149,
      tf: 8,
      tw: 5.5,
      r1: 13,
      d1: 282,
      ag: 4080,
      ix: 6.32e+07,
      iy: 4.42e+06,
      zx: 424e3,
      zy: 59300,
      sx: 475e3,
      sy: 91800,
      rx: 124,
      ry: 32.9,
      j: 86500,
      iw: 9.29e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 0.915,
      compactnessX: 'N',
      zex: 467,
      compactnessY: 'N',
      zey: 86.9
    }
  }),

  new Section({
    id: '360UB32.0_350',
    name: '360 UB 32.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 298,
      bf: 149,
      tf: 8,
      tw: 5.5,
      r1: 13,
      d1: 282,
      ag: 4080,
      ix: 6.32e+07,
      iy: 4.42e+06,
      zx: 424e3,
      zy: 59300,
      sx: 475e3,
      sy: 91800,
      rx: 124,
      ry: 32.9,
      j: 86500,
      iw: 9.29e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 0.898,
      compactnessX: 'N',
      zex: 462,
      compactnessY: 'N',
      zey: 85.7
    }
  }),

  new Section({
    id: '360UB40.4_300',
    name: '360 UB 40.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 304,
      bf: 165,
      tf: 10.2,
      tw: 6.1,
      r1: 11.4,
      d1: 284,
      ag: 5210,
      ix: 8.64e+07,
      iy: 7.65e+06,
      zx: 569e3,
      zy: 92700,
      sx: 633e3,
      sy: 142e3,
      rx: 129,
      ry: 38.3,
      j: 157e3,
      iw: 165e9,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 0.952,
      compactnessX: 'C',
      zex: 633,
      compactnessY: 'C',
      zey: 139
    }
  }),

  new Section({
    id: '360UB40.4_350',
    name: '360 UB 40.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 304,
      bf: 165,
      tf: 10.2,
      tw: 6.1,
      r1: 11.4,
      d1: 284,
      ag: 5210,
      ix: 8.64e+07,
      iy: 7.65e+06,
      zx: 569e3,
      zy: 92700,
      sx: 633e3,
      sy: 142e3,
      rx: 129,
      ry: 38.3,
      j: 157e3,
      iw: 165e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 0.936,
      compactnessX: 'N',
      zex: 629,
      compactnessY: 'N',
      zey: 138
    }
  }),

  new Section({
    id: '360UB44.7_300',
    name: '360 UB 44.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 352,
      bf: 171,
      tf: 9.7,
      tw: 6.9,
      r1: 11.4,
      d1: 333,
      ag: 5720,
      ix: 121e6,
      iy: 8.1e+06,
      zx: 689e3,
      zy: 94700,
      sx: 777e3,
      sy: 146e3,
      rx: 146,
      ry: 37.6,
      j: 161e3,
      iw: 237e9,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 0.93,
      compactnessX: 'N',
      zex: 770,
      compactnessY: 'N',
      zey: 140
    }
  }),

  new Section({
    id: '360UB44.7_350',
    name: '360 UB 44.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 352,
      bf: 171,
      tf: 9.7,
      tw: 6.9,
      r1: 11.4,
      d1: 333,
      ag: 5720,
      ix: 121e6,
      iy: 8.1e+06,
      zx: 689e3,
      zy: 94700,
      sx: 777e3,
      sy: 146e3,
      rx: 146,
      ry: 37.6,
      j: 161e3,
      iw: 237e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 0.911,
      compactnessX: 'N',
      zex: 762,
      compactnessY: 'N',
      zey: 139
    }
  }),

  new Section({
    id: '360UB46.2_300',
    name: '360 UB 46.2',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 307,
      bf: 166,
      tf: 11.8,
      tw: 6.7,
      r1: 11.4,
      d1: 284,
      ag: 5930,
      ix: 100e6,
      iy: 9.01e+06,
      zx: 654e3,
      zy: 109e3,
      sx: 729e3,
      sy: 166e3,
      rx: 130,
      ry: 39,
      j: 233e3,
      iw: 197e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.991,
      compactnessX: 'C',
      zex: 729,
      compactnessY: 'C',
      zey: 163
    }
  }),

  new Section({
    id: '360UB46.2_350',
    name: '360 UB 46.2',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 307,
      bf: 166,
      tf: 11.8,
      tw: 6.7,
      r1: 11.4,
      d1: 284,
      ag: 5930,
      ix: 100e6,
      iy: 9.01e+06,
      zx: 654e3,
      zy: 109e3,
      sx: 729e3,
      sy: 166e3,
      rx: 130,
      ry: 39,
      j: 233e3,
      iw: 197e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.972,
      compactnessX: 'C',
      zex: 729,
      compactnessY: 'C',
      zey: 163
    }
  }),

  new Section({
    id: '360UB50.7_300',
    name: '360 UB 50.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 356,
      bf: 171,
      tf: 11.5,
      tw: 7.3,
      r1: 11.4,
      d1: 333,
      ag: 6470,
      ix: 142e6,
      iy: 9.6e+06,
      zx: 798e3,
      zy: 112e3,
      sx: 897e3,
      sy: 173e3,
      rx: 148,
      ry: 38.5,
      j: 241e3,
      iw: 284e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.963,
      compactnessX: 'C',
      zex: 897,
      compactnessY: 'C',
      zey: 168
    }
  }),

  new Section({
    id: '360UB50.7_350',
    name: '360 UB 50.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 356,
      bf: 171,
      tf: 11.5,
      tw: 7.3,
      r1: 11.4,
      d1: 333,
      ag: 6470,
      ix: 142e6,
      iy: 9.6e+06,
      zx: 798e3,
      zy: 112e3,
      sx: 897e3,
      sy: 173e3,
      rx: 148,
      ry: 38.5,
      j: 241e3,
      iw: 284e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.943,
      compactnessX: 'C',
      zex: 897,
      compactnessY: 'C',
      zey: 168
    }
  }),

  new Section({
    id: '360UB56.7_300',
    name: '360 UB 56.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 359,
      bf: 172,
      tf: 13,
      tw: 8,
      r1: 11.4,
      d1: 333,
      ag: 7240,
      ix: 161e6,
      iy: 11e6,
      zx: 899e3,
      zy: 128e3,
      sx: 1010e3,
      sy: 198e3,
      rx: 149,
      ry: 39,
      j: 338e3,
      iw: 330e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.996,
      compactnessX: 'C',
      zex: 1010,
      compactnessY: 'C',
      zey: 193
    }
  }),

  new Section({
    id: '360UB56.7_350',
    name: '360 UB 56.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 359,
      bf: 172,
      tf: 13,
      tw: 8,
      r1: 11.4,
      d1: 333,
      ag: 7240,
      ix: 161e6,
      iy: 11e6,
      zx: 899e3,
      zy: 128e3,
      sx: 1010e3,
      sy: 198e3,
      rx: 149,
      ry: 39,
      j: 338e3,
      iw: 330e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.974,
      compactnessX: 'C',
      zex: 1010,
      compactnessY: 'C',
      zey: 193
    }
  }),

  new Section({
    id: '410UB53.7_300',
    name: '410 UB 53.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 403,
      bf: 178,
      tf: 10.9,
      tw: 7.6,
      r1: 11.4,
      d1: 381,
      ag: 6890,
      ix: 188e6,
      iy: 1.03e+07,
      zx: 933e3,
      zy: 115e3,
      sx: 1060e3,
      sy: 179e3,
      rx: 165,
      ry: 38.6,
      j: 234e3,
      iw: 394e9,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 0.913,
      compactnessX: 'C',
      zex: 1060,
      compactnessY: 'C',
      zey: 173
    }
  }),

  new Section({
    id: '410UB53.7_350',
    name: '410 UB 53.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 403,
      bf: 178,
      tf: 10.9,
      tw: 7.6,
      r1: 11.4,
      d1: 381,
      ag: 6890,
      ix: 188e6,
      iy: 1.03e+07,
      zx: 933e3,
      zy: 115e3,
      sx: 1060e3,
      sy: 179e3,
      rx: 165,
      ry: 38.6,
      j: 234e3,
      iw: 394e9,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 0.894,
      compactnessX: 'N',
      zex: 1050,
      compactnessY: 'N',
      zey: 172
    }
  }),

  new Section({
    id: '410UB59.7_300',
    name: '410 UB 59.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 406,
      bf: 178,
      tf: 12.8,
      tw: 7.8,
      r1: 11.4,
      d1: 381,
      ag: 7640,
      ix: 216e6,
      iy: 1.21e+07,
      zx: 1060e3,
      zy: 135e3,
      sx: 1200e3,
      sy: 209e3,
      rx: 168,
      ry: 39.7,
      j: 337e3,
      iw: 467e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.938,
      compactnessX: 'C',
      zex: 1200,
      compactnessY: 'C',
      zey: 203
    }
  }),

  new Section({
    id: '410UB59.7_350',
    name: '410 UB 59.7',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 406,
      bf: 178,
      tf: 12.8,
      tw: 7.8,
      r1: 11.4,
      d1: 381,
      ag: 7640,
      ix: 216e6,
      iy: 1.21e+07,
      zx: 1060e3,
      zy: 135e3,
      sx: 1200e3,
      sy: 209e3,
      rx: 168,
      ry: 39.7,
      j: 337e3,
      iw: 467e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.918,
      compactnessX: 'C',
      zex: 1200,
      compactnessY: 'C',
      zey: 203
    }
  }),

  new Section({
    id: '460UB67.1_300',
    name: '460 UB 67.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 454,
      bf: 190,
      tf: 12.7,
      tw: 8.5,
      r1: 11.4,
      d1: 428,
      ag: 8580,
      ix: 296e6,
      iy: 1.45e+07,
      zx: 1300e3,
      zy: 153e3,
      sx: 1480e3,
      sy: 238e3,
      rx: 186,
      ry: 41.2,
      j: 378e3,
      iw: 708e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.922,
      compactnessX: 'C',
      zex: 1480,
      compactnessY: 'C',
      zey: 230
    }
  }),

  new Section({
    id: '460UB67.1_350',
    name: '460 UB 67.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 454,
      bf: 190,
      tf: 12.7,
      tw: 8.5,
      r1: 11.4,
      d1: 428,
      ag: 8580,
      ix: 296e6,
      iy: 1.45e+07,
      zx: 1300e3,
      zy: 153e3,
      sx: 1480e3,
      sy: 238e3,
      rx: 186,
      ry: 41.2,
      j: 378e3,
      iw: 708e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.901,
      compactnessX: 'C',
      zex: 1480,
      compactnessY: 'C',
      zey: 230
    }
  }),

  new Section({
    id: '460UB74.6_300',
    name: '460 UB 74.6',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 457,
      bf: 190,
      tf: 14.5,
      tw: 9.1,
      r1: 11.4,
      d1: 428,
      ag: 9520,
      ix: 335e6,
      iy: 1.66e+07,
      zx: 1460e3,
      zy: 175e3,
      sx: 1660e3,
      sy: 271e3,
      rx: 188,
      ry: 41.8,
      j: 530e3,
      iw: 815e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.948,
      compactnessX: 'C',
      zex: 1660,
      compactnessY: 'C',
      zey: 262
    }
  }),

  new Section({
    id: '460UB74.6_350',
    name: '460 UB 74.6',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 457,
      bf: 190,
      tf: 14.5,
      tw: 9.1,
      r1: 11.4,
      d1: 428,
      ag: 9520,
      ix: 335e6,
      iy: 1.66e+07,
      zx: 1460e3,
      zy: 175e3,
      sx: 1660e3,
      sy: 271e3,
      rx: 188,
      ry: 41.8,
      j: 530e3,
      iw: 815e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.926,
      compactnessX: 'C',
      zex: 1660,
      compactnessY: 'C',
      zey: 262
    }
  }),

  new Section({
    id: '460UB82.1_300',
    name: '460 UB 82.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 460,
      bf: 191,
      tf: 16,
      tw: 9.9,
      r1: 11.4,
      d1: 428,
      ag: 10500,
      ix: 372e6,
      iy: 1.86e+07,
      zx: 1610e3,
      zy: 195e3,
      sx: 1840e3,
      sy: 303e3,
      rx: 188,
      ry: 42.2,
      j: 701e3,
      iw: 919e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.979,
      compactnessX: 'C',
      zex: 1840,
      compactnessY: 'C',
      zey: 292
    }
  }),

  new Section({
    id: '460UB82.1_350',
    name: '460 UB 82.1',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 460,
      bf: 191,
      tf: 16,
      tw: 9.9,
      r1: 11.4,
      d1: 428,
      ag: 10500,
      ix: 372e6,
      iy: 1.86e+07,
      zx: 1610e3,
      zy: 195e3,
      sx: 1840e3,
      sy: 303e3,
      rx: 188,
      ry: 42.2,
      j: 701e3,
      iw: 919e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.956,
      compactnessX: 'C',
      zex: 1840,
      compactnessY: 'C',
      zey: 292
    }
  }),

  new Section({
    id: '530UB82.0_300',
    name: '530 UB 82.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 528,
      bf: 209,
      tf: 13.2,
      tw: 9.6,
      r1: 14,
      d1: 502,
      ag: 10500,
      ix: 477e6,
      iy: 2.01e+07,
      zx: 1810e3,
      zy: 193e3,
      sx: 2070e3,
      sy: 301e3,
      rx: 213,
      ry: 43.8,
      j: 526e3,
      iw: 1330e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.902,
      compactnessX: 'C',
      zex: 2070,
      compactnessY: 'C',
      zey: 289
    }
  }),

  new Section({
    id: '530UB82.0_350',
    name: '530 UB 82.0',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 528,
      bf: 209,
      tf: 13.2,
      tw: 9.6,
      r1: 14,
      d1: 502,
      ag: 10500,
      ix: 477e6,
      iy: 2.01e+07,
      zx: 1810e3,
      zy: 193e3,
      sx: 2070e3,
      sy: 301e3,
      rx: 213,
      ry: 43.8,
      j: 526e3,
      iw: 1330e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 880,
      compactnessX: 'C',
      zex: 2070,
      compactnessY: 'C',
      zey: 289
    }
  }),

  new Section({
    id: '530UB92.4_300',
    name: '530 UB 92.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 533,
      bf: 209,
      tf: 15.6,
      tw: 10.2,
      r1: 14,
      d1: 502,
      ag: 11800,
      ix: 554e6,
      iy: 2.38e+07,
      zx: 2080e3,
      zy: 228e3,
      sx: 2370e3,
      sy: 355e3,
      rx: 217,
      ry: 44.9,
      j: 775e3,
      iw: 1590e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.928,
      compactnessX: 'C',
      zex: 2370,
      compactnessY: 'C',
      zey: 342
    }
  }),

  new Section({
    id: '530UB92.4_350',
    name: '530 UB 92.4',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 533,
      bf: 209,
      tf: 15.6,
      tw: 10.2,
      r1: 14,
      d1: 502,
      ag: 11800,
      ix: 554e6,
      iy: 2.38e+07,
      zx: 2080e3,
      zy: 228e3,
      sx: 2370e3,
      sy: 355e3,
      rx: 217,
      ry: 44.9,
      j: 775e3,
      iw: 1590e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.907,
      compactnessX: 'C',
      zex: 2370,
      compactnessY: 'C',
      zey: 342
    }
  }),

  new Section({
    id: '610UB101_300',
    name: '610 UB 101',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 602,
      bf: 228,
      tf: 14.8,
      tw: 10.6,
      r1: 14,
      d1: 572,
      ag: 13000,
      ix: 761e6,
      iy: 2.93e+07,
      zx: 2530e3,
      zy: 257e3,
      sx: 2900e3,
      sy: 402e3,
      rx: 242,
      ry: 47.5,
      j: 790e3,
      iw: 2530e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 0.888,
      compactnessX: 'C',
      zex: 2900,
      compactnessY: 'C',
      zey: 386
    }
  }),

  new Section({
    id: '610UB101_350',
    name: '610 UB 101',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 602,
      bf: 228,
      tf: 14.8,
      tw: 10.6,
      r1: 14,
      d1: 572,
      ag: 13000,
      ix: 761e6,
      iy: 2.93e+07,
      zx: 2530e3,
      zy: 257e3,
      sx: 2900e3,
      sy: 402e3,
      rx: 242,
      ry: 47.5,
      j: 790e3,
      iw: 2530e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 0.867,
      compactnessX: 'C',
      zex: 2900,
      compactnessY: 'C',
      zey: 386
    }
  }),

  new Section({
    id: '610UB113_300',
    name: '610 UB 113',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 607,
      bf: 228,
      tf: 17.3,
      tw: 11.2,
      r1: 14,
      d1: 572,
      ag: 14500,
      ix: 875e6,
      iy: 3.43e+07,
      zx: 2880e3,
      zy: 300e3,
      sx: 3290e3,
      sy: 469e3,
      rx: 246,
      ry: 48.7,
      j: 1140e3,
      iw: 2980e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.926,
      compactnessX: 'C',
      zex: 3290,
      compactnessY: 'C',
      zey: 451
    }
  }),

  new Section({
    id: '610UB113_350',
    name: '610 UB 113',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 607,
      bf: 228,
      tf: 17.3,
      tw: 11.2,
      r1: 14,
      d1: 572,
      ag: 14500,
      ix: 875e6,
      iy: 3.43e+07,
      zx: 2880e3,
      zy: 300e3,
      sx: 3290e3,
      sy: 469e3,
      rx: 246,
      ry: 48.7,
      j: 1140e3,
      iw: 2980e9,
      fy: 340,
      fyw: 340,
      fu: 480,
      kf: 0.891,
      compactnessX: 'C',
      zex: 3290,
      compactnessY: 'C',
      zey: 451
    }
  }),

  new Section({
    id: '610UB125_300',
    name: '610 UB 125',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 612,
      bf: 229,
      tf: 19.6,
      tw: 11.9,
      r1: 14,
      d1: 572,
      ag: 16000,
      ix: 986e6,
      iy: 3.93e+07,
      zx: 3230e3,
      zy: 343e3,
      sx: 3680e3,
      sy: 536e3,
      rx: 249,
      ry: 49.6,
      j: 1560e3,
      iw: 3450e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 0.95,
      compactnessX: 'C',
      zex: 3680,
      compactnessY: 'C',
      zey: 515
    }
  }),

  new Section({
    id: '610UB125_350',
    name: '610 UB 125',
    category: SECTION_CATEGORIES.UNIVERSAL_BEAMS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 612,
      bf: 229,
      tf: 19.6,
      tw: 11.9,
      r1: 14,
      d1: 572,
      ag: 16000,
      ix: 986e6,
      iy: 3.93e+07,
      zx: 3230e3,
      zy: 343e3,
      sx: 3680e3,
      sy: 536e3,
      rx: 249,
      ry: 49.6,
      j: 1560e3,
      iw: 3450e9,
      fy: 340,
      fyw: 340,
      fu: 480,
      kf: 0.916,
      compactnessX: 'C',
      zex: 3680,
      compactnessY: 'C',
      zey: 515
    }
  }),

  new Section({
    id: '100UC14.8_300',
    name: '100 UC 14.8',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 97,
      bf: 99,
      tf: 7,
      tw: 5,
      r1: 10,
      d1: 83,
      ag: 1890,
      ix: 3.18e+06,
      iy: 1.14e+06,
      zx: 65600,
      zy: 22900,
      sx: 74400,
      sy: 35200,
      rx: 41.1,
      ry: 24.5,
      j: 34900,
      iw: 2.3e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 74.4,
      compactnessY: 'C',
      zey: 34.4
    }
  }),

  new Section({
    id: '100UC14.8_350',
    name: '100 UC 14.8',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 97,
      bf: 99,
      tf: 7,
      tw: 5,
      r1: 10,
      d1: 83,
      ag: 1890,
      ix: 3.18e+06,
      iy: 1.14e+06,
      zx: 65600,
      zy: 22900,
      sx: 74400,
      sy: 35200,
      rx: 41.1,
      ry: 24.5,
      j: 34900,
      iw: 2.3e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 74.4,
      compactnessY: 'C',
      zey: 34.4
    }
  }),

  new Section({
    id: '150UC23.4_300',
    name: '150 UC 23.4',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 152,
      bf: 152,
      tf: 6.8,
      tw: 6.1,
      r1: 8.9,
      d1: 139,
      ag: 2980,
      ix: 1.26e+07,
      iy: 3.98e+06,
      zx: 166e3,
      zy: 52400,
      sx: 184e3,
      sy: 80200,
      rx: 65.1,
      ry: 36.6,
      j: 50200,
      iw: 2.11e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 176,
      compactnessY: 'N',
      zey: 73.5
    }
  }),

  new Section({
    id: '150UC23.4_350',
    name: '150 UC 23.4',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 152,
      bf: 152,
      tf: 6.8,
      tw: 6.1,
      r1: 8.9,
      d1: 139,
      ag: 2980,
      ix: 1.26e+07,
      iy: 3.98e+06,
      zx: 166e3,
      zy: 52400,
      sx: 184e3,
      sy: 80200,
      rx: 65.1,
      ry: 36.6,
      j: 50200,
      iw: 2.11e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 174,
      compactnessY: 'N',
      zey: 72.3
    }
  }),

  new Section({
    id: '150UC30.0_300',
    name: '150 UC 30.0',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 158,
      bf: 153,
      tf: 9.4,
      tw: 6.6,
      r1: 8.9,
      d1: 139,
      ag: 3860,
      ix: 1.76e+07,
      iy: 5.62e+06,
      zx: 223e3,
      zy: 73400,
      sx: 250e3,
      sy: 112e3,
      rx: 67.5,
      ry: 38.1,
      j: 109e3,
      iw: 3.08e+10,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 250,
      compactnessY: 'C',
      zey: 110
    }
  }),

  new Section({
    id: '150UC30.0_350',
    name: '150 UC 30.0',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 158,
      bf: 153,
      tf: 9.4,
      tw: 6.6,
      r1: 8.9,
      d1: 139,
      ag: 3860,
      ix: 1.76e+07,
      iy: 5.62e+06,
      zx: 223e3,
      zy: 73400,
      sx: 250e3,
      sy: 112e3,
      rx: 67.5,
      ry: 38.1,
      j: 109e3,
      iw: 3.08e+10,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 248,
      compactnessY: 'N',
      zey: 109
    }
  }),

  new Section({
    id: '150UC37.2_300',
    name: '150 UC 37.2',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 162,
      bf: 154,
      tf: 11.5,
      tw: 8.1,
      r1: 8.9,
      d1: 139,
      ag: 4730,
      ix: 2.22e+07,
      iy: 7.01e+06,
      zx: 274e3,
      zy: 91e3,
      sx: 310e3,
      sy: 139e3,
      rx: 68.4,
      ry: 38.5,
      j: 197e3,
      iw: 3.96e+10,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 310,
      compactnessY: 'C',
      zey: 137
    }
  }),

  new Section({
    id: '150UC37.2_350',
    name: '150 UC 37.2',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 162,
      bf: 154,
      tf: 11.5,
      tw: 8.1,
      r1: 8.9,
      d1: 139,
      ag: 4730,
      ix: 2.22e+07,
      iy: 7.01e+06,
      zx: 274e3,
      zy: 91e3,
      sx: 310e3,
      sy: 139e3,
      rx: 68.4,
      ry: 38.5,
      j: 197e3,
      iw: 3.96e+10,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 310,
      compactnessY: 'C',
      zey: 137
    }
  }),

  new Section({
    id: '200UC46.2_300',
    name: '200 UC 46.2',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 203,
      bf: 203,
      tf: 11,
      tw: 7.3,
      r1: 11.4,
      d1: 181,
      ag: 5900,
      ix: 4.59e+07,
      iy: 1.53e+07,
      zx: 451e3,
      zy: 151e3,
      sx: 500e3,
      sy: 230e3,
      rx: 88.2,
      ry: 51,
      j: 228e3,
      iw: 142e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 494,
      compactnessY: 'N',
      zey: 223
    }
  }),

  new Section({
    id: '200UC46.2_350',
    name: '200 UC 46.2',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 203,
      bf: 203,
      tf: 11,
      tw: 7.3,
      r1: 11.4,
      d1: 181,
      ag: 5900,
      ix: 4.59e+07,
      iy: 1.53e+07,
      zx: 451e3,
      zy: 151e3,
      sx: 500e3,
      sy: 230e3,
      rx: 88.2,
      ry: 51,
      j: 228e3,
      iw: 142e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 490,
      compactnessY: 'N',
      zey: 219
    }
  }),

  new Section({
    id: '200UC52.2_300',
    name: '200 UC 52.2',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 206,
      bf: 204,
      tf: 12.5,
      tw: 8,
      r1: 11.4,
      d1: 181,
      ag: 6660,
      ix: 5.28e+07,
      iy: 1.77e+07,
      zx: 512e3,
      zy: 174e3,
      sx: 570e3,
      sy: 264e3,
      rx: 89.1,
      ry: 51.5,
      j: 325e3,
      iw: 166e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 570,
      compactnessY: 'C',
      zey: 260
    }
  }),

  new Section({
    id: '200UC52.2_350',
    name: '200 UC 52.2',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 206,
      bf: 204,
      tf: 12.5,
      tw: 8,
      r1: 11.4,
      d1: 181,
      ag: 6660,
      ix: 5.28e+07,
      iy: 1.77e+07,
      zx: 512e3,
      zy: 174e3,
      sx: 570e3,
      sy: 264e3,
      rx: 89.1,
      ry: 51.5,
      j: 325e3,
      iw: 166e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 569,
      compactnessY: 'N',
      zey: 260
    }
  }),

  new Section({
    id: '200UC59.5_300',
    name: '200 UC 59.5',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 210,
      bf: 205,
      tf: 14.2,
      tw: 9.3,
      r1: 11.4,
      d1: 181,
      ag: 7620,
      ix: 6.13e+07,
      iy: 2.04e+07,
      zx: 584e3,
      zy: 199e3,
      sx: 656e3,
      sy: 303e3,
      rx: 89.7,
      ry: 51.7,
      j: 477e3,
      iw: 195e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 656,
      compactnessY: 'C',
      zey: 299
    }
  }),

  new Section({
    id: '200UC59.5_350',
    name: '200 UC 59.5',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 210,
      bf: 205,
      tf: 14.2,
      tw: 9.3,
      r1: 11.4,
      d1: 181,
      ag: 7620,
      ix: 6.13e+07,
      iy: 2.04e+07,
      zx: 584e3,
      zy: 199e3,
      sx: 656e3,
      sy: 303e3,
      rx: 89.7,
      ry: 51.7,
      j: 477e3,
      iw: 195e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 656,
      compactnessY: 'C',
      zey: 299
    }
  }),

  new Section({
    id: '250UC72.9_300',
    name: '250 UC 72.9',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 254,
      bf: 254,
      tf: 14.2,
      tw: 8.6,
      r1: 14,
      d1: 225,
      ag: 9320,
      ix: 114e6,
      iy: 3.88e+07,
      zx: 897e3,
      zy: 306e3,
      sx: 992e3,
      sy: 463e3,
      rx: 111,
      ry: 64.5,
      j: 586e3,
      iw: 557e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 986,
      compactnessY: 'N',
      zey: 454
    }
  }),

  new Section({
    id: '250UC72.9_350',
    name: '250 UC 72.9',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 254,
      bf: 254,
      tf: 14.2,
      tw: 8.6,
      r1: 14,
      d1: 225,
      ag: 9320,
      ix: 114e6,
      iy: 3.88e+07,
      zx: 897e3,
      zy: 306e3,
      sx: 992e3,
      sy: 463e3,
      rx: 111,
      ry: 64.5,
      j: 586e3,
      iw: 557e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 977,
      compactnessY: 'N',
      zey: 448
    }
  }),

  new Section({
    id: '250UC89.5_300',
    name: '250 UC 89.5',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 260,
      bf: 256,
      tf: 17.3,
      tw: 10.5,
      r1: 14,
      d1: 225,
      ag: 11400,
      ix: 143e6,
      iy: 4.84e+07,
      zx: 1100e3,
      zy: 378e3,
      sx: 1230e3,
      sy: 575e3,
      rx: 112,
      ry: 65.2,
      j: 1040e3,
      iw: 713e9,
      fy: 280,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 1230,
      compactnessY: 'C',
      zey: 567
    }
  }),

  new Section({
    id: '250UC89.5_350',
    name: '250 UC 89.5',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 260,
      bf: 256,
      tf: 17.3,
      tw: 10.5,
      r1: 14,
      d1: 225,
      ag: 11400,
      ix: 143e6,
      iy: 4.84e+07,
      zx: 1100e3,
      zy: 378e3,
      sx: 1230e3,
      sy: 575e3,
      rx: 112,
      ry: 65.2,
      j: 1040e3,
      iw: 713e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 1230,
      compactnessY: 'C',
      zey: 567
    }
  }),

  new Section({
    id: '310UC96.8_300',
    name: '310 UC 96.8',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 308,
      bf: 305,
      tf: 15.4,
      tw: 9.9,
      r1: 16.5,
      d1: 277,
      ag: 12400,
      ix: 223e6,
      iy: 7.29e+07,
      zx: 1450e3,
      zy: 478e3,
      sx: 1600e3,
      sy: 725e3,
      rx: 134,
      ry: 76.7,
      j: 928e3,
      iw: 1560e9,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'N',
      zex: 1560,
      compactnessY: 'N',
      zey: 694
    }
  }),

  new Section({
    id: '310UC96.8_350',
    name: '310 UC 96.8',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 308,
      bf: 305,
      tf: 15.4,
      tw: 9.9,
      r1: 16.5,
      d1: 277,
      ag: 12400,
      ix: 223e6,
      iy: 7.29e+07,
      zx: 1450e3,
      zy: 478e3,
      sx: 1600e3,
      sy: 725e3,
      rx: 134,
      ry: 76.7,
      j: 928e3,
      iw: 1560e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 1550,
      compactnessY: 'N',
      zey: 684
    }
  }),

  new Section({
    id: '310UC118_300',
    name: '310 UC 118',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 315,
      bf: 307,
      tf: 18.7,
      tw: 11.9,
      r1: 16.5,
      d1: 277,
      ag: 15000,
      ix: 277e6,
      iy: 9.02e+07,
      zx: 1760e3,
      zy: 588e3,
      sx: 1960e3,
      sy: 893e3,
      rx: 136,
      ry: 77.5,
      j: 1630e3,
      iw: 1980e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 1960,
      compactnessY: 'C',
      zey: 882
    }
  }),

  new Section({
    id: '310UC118_350',
    name: '310 UC 118',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 315,
      bf: 307,
      tf: 18.7,
      tw: 11.9,
      r1: 16.5,
      d1: 277,
      ag: 15000,
      ix: 277e6,
      iy: 9.02e+07,
      zx: 1760e3,
      zy: 588e3,
      sx: 1960e3,
      sy: 893e3,
      rx: 136,
      ry: 77.5,
      j: 1630e3,
      iw: 1980e9,
      fy: 340,
      fyw: 340,
      fu: 480,
      kf: 1,
      compactnessX: 'N',
      zex: 1950,
      compactnessY: 'N',
      zey: 878
    }
  }),

  new Section({
    id: '310UC137_300',
    name: '310 UC 137',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 321,
      bf: 309,
      tf: 21.7,
      tw: 13.8,
      r1: 16.5,
      d1: 277,
      ag: 17500,
      ix: 329e6,
      iy: 107e6,
      zx: 2050e3,
      zy: 691e3,
      sx: 2300e3,
      sy: 1050e3,
      rx: 137,
      ry: 78.2,
      j: 2520e3,
      iw: 2390e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 2300,
      compactnessY: 'C',
      zey: 1040
    }
  }),

  new Section({
    id: '310UC137_350',
    name: '310 UC 137',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 321,
      bf: 309,
      tf: 21.7,
      tw: 13.8,
      r1: 16.5,
      d1: 277,
      ag: 17500,
      ix: 329e6,
      iy: 107e6,
      zx: 2050e3,
      zy: 691e3,
      sx: 2300e3,
      sy: 1050e3,
      rx: 137,
      ry: 78.2,
      j: 2520e3,
      iw: 2390e9,
      fy: 340,
      fyw: 340,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 2300,
      compactnessY: 'C',
      zey: 1040
    }
  }),

  new Section({
    id: '310UC158_300',
    name: '310 UC 158',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 327,
      bf: 311,
      tf: 25,
      tw: 15.7,
      r1: 16.5,
      d1: 277,
      ag: 20100,
      ix: 388e6,
      iy: 125e6,
      zx: 2370e3,
      zy: 807e3,
      sx: 2680e3,
      sy: 1230e3,
      rx: 139,
      ry: 78.9,
      j: 3810e3,
      iw: 2860e9,
      fy: 280,
      fyw: 300,
      fu: 440,
      kf: 1,
      compactnessX: 'C',
      zex: 2680,
      compactnessY: 'C',
      zey: 1210
    }
  }),

  new Section({
    id: '310UC158_350',
    name: '310 UC 158',
    category: SECTION_CATEGORIES.UNIVERSAL_COLUMNS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 327,
      bf: 311,
      tf: 25,
      tw: 15.7,
      r1: 16.5,
      d1: 277,
      ag: 20100,
      ix: 388e6,
      iy: 125e6,
      zx: 2370e3,
      zy: 807e3,
      sx: 2680e3,
      sy: 1230e3,
      rx: 139,
      ry: 78.9,
      j: 3810e3,
      iw: 2860e9,
      fy: 340,
      fyw: 340,
      fu: 480,
      kf: 1,
      compactnessX: 'C',
      zex: 2680,
      compactnessY: 'C',
      zey: 1210
    }
  }),

  new Section({
    id: '75PFC5.92_300',
    name: '75 PFC 5.92',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 75,
      bf: 40,
      tf: 6.1,
      tw: 3.8,
      r1: 8,
      d1: 62.8,
      ag: 754,
      ix: 683000,
      iy: 120000,
      zx: 18200,
      zy: 4560,
      sx: 21400,
      sy: 8200,
      rx: 30.1,
      ry: 12.6,
      j: 8420,
      iw: 1.03e+08,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 21.4,
      compactnessY: 'nan',
      zey: 6.84
    }
  }),

  new Section({
    id: '75PFC5.92_350',
    name: '75 PFC 5.92',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 75,
      bf: 40,
      tf: 6.1,
      tw: 3.8,
      r1: 8,
      d1: 62.8,
      ag: 754,
      ix: 683000,
      iy: 120000,
      zx: 18200,
      zy: 4560,
      sx: 21400,
      sy: 8200,
      rx: 30.1,
      ry: 12.6,
      j: 8420,
      iw: 1.03e+08,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 21.4,
      compactnessY: 'nan',
      zey: 6.84
    }
  }),

  new Section({
    id: '100PFC8.33_300',
    name: '100 PFC 8.33',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 100,
      bf: 50,
      tf: 6.7,
      tw: 4.2,
      r1: 8,
      d1: 86.6,
      ag: 1060,
      ix: 1.74e+06,
      iy: 267000,
      zx: 34700,
      zy: 8010,
      sx: 40300,
      sy: 14400,
      rx: 40.4,
      ry: 15.9,
      j: 13600,
      iw: 4.19e+08,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 40.3,
      compactnessY: 'nan',
      zey: 12
    }
  }),

  new Section({
    id: '100PFC8.33_350',
    name: '100 PFC 8.33',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 100,
      bf: 50,
      tf: 6.7,
      tw: 4.2,
      r1: 8,
      d1: 86.6,
      ag: 1060,
      ix: 1.74e+06,
      iy: 267000,
      zx: 34700,
      zy: 8010,
      sx: 40300,
      sy: 14400,
      rx: 40.4,
      ry: 15.9,
      j: 13600,
      iw: 4.19e+08,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 40.3,
      compactnessY: 'nan',
      zey: 12
    }
  }),

  new Section({
    id: '125PFC11.9_300',
    name: '125 PFC 11.9',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 125,
      bf: 65,
      tf: 7.5,
      tw: 4.7,
      r1: 8,
      d1: 110,
      ag: 1520,
      ix: 3.97e+06,
      iy: 658000,
      zx: 63500,
      zy: 15200,
      sx: 73e3,
      sy: 27200,
      rx: 51.1,
      ry: 20.8,
      j: 23800,
      iw: 1.64e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 72.8,
      compactnessY: 'nan',
      zey: 22.8
    }
  }),

  new Section({
    id: '125PFC11.9_350',
    name: '125 PFC 11.9',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 125,
      bf: 65,
      tf: 7.5,
      tw: 4.7,
      r1: 8,
      d1: 110,
      ag: 1520,
      ix: 3.97e+06,
      iy: 658000,
      zx: 63500,
      zy: 15200,
      sx: 73e3,
      sy: 27200,
      rx: 51.1,
      ry: 20.8,
      j: 23800,
      iw: 1.64e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 72,
      compactnessY: 'nan',
      zey: 22.5
    }
  }),

  new Section({
    id: '150PFC17.7_300',
    name: '150 PFC 17.7',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 150,
      bf: 75,
      tf: 9.5,
      tw: 6,
      r1: 10,
      d1: 131,
      ag: 2250,
      ix: 8.34e+06,
      iy: 1.29e+06,
      zx: 111e3,
      zy: 25700,
      sx: 129e3,
      sy: 46e3,
      rx: 60.8,
      ry: 23.9,
      j: 56600,
      iw: 4.56e+09,
      fy: 320,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 129,
      compactnessY: 'nan',
      zey: 38.5
    }
  }),

  new Section({
    id: '150PFC17.7_350',
    name: '150 PFC 17.7',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 150,
      bf: 75,
      tf: 9.5,
      tw: 6,
      r1: 10,
      d1: 131,
      ag: 2250,
      ix: 8.34e+06,
      iy: 1.29e+06,
      zx: 111e3,
      zy: 25700,
      sx: 129e3,
      sy: 46e3,
      rx: 60.8,
      ry: 23.9,
      j: 56600,
      iw: 4.56e+09,
      fy: 360,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 129,
      compactnessY: 'nan',
      zey: 38.5
    }
  }),

  new Section({
    id: '180PFC20.9_300',
    name: '180 PFC 20.9',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 180,
      bf: 75,
      tf: 11,
      tw: 6,
      r1: 12,
      d1: 158,
      ag: 2660,
      ix: 1.41e+07,
      iy: 1.51e+06,
      zx: 157e3,
      zy: 29900,
      sx: 182e3,
      sy: 53800,
      rx: 72.9,
      ry: 23.8,
      j: 84500,
      iw: 7.75e+09,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 182,
      compactnessY: 'nan',
      zey: 44.9
    }
  }),

  new Section({
    id: '180PFC20.9_350',
    name: '180 PFC 20.9',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 180,
      bf: 75,
      tf: 11,
      tw: 6,
      r1: 12,
      d1: 158,
      ag: 2660,
      ix: 1.41e+07,
      iy: 1.51e+06,
      zx: 157e3,
      zy: 29900,
      sx: 182e3,
      sy: 53800,
      rx: 72.9,
      ry: 23.8,
      j: 84500,
      iw: 7.75e+09,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 182,
      compactnessY: 'nan',
      zey: 44.1
    }
  }),

  new Section({
    id: '200PFC22.9_300',
    name: '200 PFC 22.9',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 200,
      bf: 75,
      tf: 12,
      tw: 6,
      r1: 12,
      d1: 176,
      ag: 2920,
      ix: 1.91e+07,
      iy: 1.65e+06,
      zx: 191e3,
      zy: 32700,
      sx: 221e3,
      sy: 58900,
      rx: 80.9,
      ry: 23.8,
      j: 105e3,
      iw: 1.05e+10,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 221,
      compactnessY: 'nan',
      zey: 46.7
    }
  }),

  new Section({
    id: '200PFC22.9_350',
    name: '200 PFC 22.9',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 200,
      bf: 75,
      tf: 12,
      tw: 6,
      r1: 12,
      d1: 176,
      ag: 2920,
      ix: 1.91e+07,
      iy: 1.65e+06,
      zx: 191e3,
      zy: 32700,
      sx: 221e3,
      sy: 58900,
      rx: 80.9,
      ry: 23.8,
      j: 105e3,
      iw: 1.05e+10,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 221,
      compactnessY: 'nan',
      zey: 44.5
    }
  }),

  new Section({
    id: '230PFC25.1_300',
    name: '230 PFC 25.1',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 230,
      bf: 75,
      tf: 12,
      tw: 6.5,
      r1: 12,
      d1: 206,
      ag: 3200,
      ix: 2.68e+07,
      iy: 1.76e+06,
      zx: 233e3,
      zy: 33600,
      sx: 271e3,
      sy: 61e3,
      rx: 91.4,
      ry: 23.5,
      j: 112e3,
      iw: 1.49e+10,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 271,
      compactnessY: 'nan',
      zey: 45.1
    }
  }),

  new Section({
    id: '230PFC25.1_350',
    name: '230 PFC 25.1',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 230,
      bf: 75,
      tf: 12,
      tw: 6.5,
      r1: 12,
      d1: 206,
      ag: 3200,
      ix: 2.68e+07,
      iy: 1.76e+06,
      zx: 233e3,
      zy: 33600,
      sx: 271e3,
      sy: 61e3,
      rx: 91.4,
      ry: 23.5,
      j: 112e3,
      iw: 1.49e+10,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 271,
      compactnessY: 'nan',
      zey: 42.6
    }
  }),

  new Section({
    id: '250PFC35.5_300',
    name: '250 PFC 35.5',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 250,
      bf: 90,
      tf: 15,
      tw: 8,
      r1: 12,
      d1: 220,
      ag: 4520,
      ix: 4.51e+07,
      iy: 3.64e+06,
      zx: 361e3,
      zy: 59300,
      sx: 421e3,
      sy: 107e3,
      rx: 99.9,
      ry: 28.4,
      j: 248e3,
      iw: 3.59e+10,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 421,
      compactnessY: 'nan',
      zey: 88.7
    }
  }),

  new Section({
    id: '250PFC35.5_350',
    name: '250 PFC 35.5',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 250,
      bf: 90,
      tf: 15,
      tw: 8,
      r1: 12,
      d1: 220,
      ag: 4520,
      ix: 4.51e+07,
      iy: 3.64e+06,
      zx: 361e3,
      zy: 59300,
      sx: 421e3,
      sy: 107e3,
      rx: 99.9,
      ry: 28.4,
      j: 248e3,
      iw: 3.59e+10,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 421,
      compactnessY: 'nan',
      zey: 84.9
    }
  }),

  new Section({
    id: '300PFC40.1_300',
    name: '300 PFC 40.1',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 300,
      bf: 90,
      tf: 16,
      tw: 8,
      r1: 14,
      d1: 268,
      ag: 5110,
      ix: 7.24e+07,
      iy: 4.04e+06,
      zx: 483e3,
      zy: 64400,
      sx: 564e3,
      sy: 117e3,
      rx: 119,
      ry: 28.1,
      j: 304e3,
      iw: 5.81e+10,
      fy: 300,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 564,
      compactnessY: 'nan',
      zey: 82.3
    }
  }),

  new Section({
    id: '300PFC40.1_350',
    name: '300 PFC 40.1',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 300,
      bf: 90,
      tf: 16,
      tw: 8,
      r1: 14,
      d1: 268,
      ag: 5110,
      ix: 7.24e+07,
      iy: 4.04e+06,
      zx: 483e3,
      zy: 64400,
      sx: 564e3,
      sy: 117e3,
      rx: 119,
      ry: 28.1,
      j: 304e3,
      iw: 5.81e+10,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 564,
      compactnessY: 'nan',
      zey: 77.2
    }
  }),

  new Section({
    id: '380PFC55.2_300',
    name: '380 PFC 55.2',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust300',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 380,
      bf: 100,
      tf: 17.5,
      tw: 10,
      r1: 14,
      d1: 345,
      ag: 7030,
      ix: 152e6,
      iy: 6.48e+06,
      zx: 798e3,
      zy: 89400,
      sx: 946e3,
      sy: 161e3,
      rx: 147,
      ry: 30.4,
      j: 491e3,
      iw: 152e9,
      fy: 280,
      fyw: 320,
      fu: 440,
      kf: 1,
      compactnessX: 'nan',
      zex: 946,
      compactnessY: 'nan',
      zey: 115
    }
  }),

  new Section({
    id: '380PFC55.2_350',
    name: '380 PFC 55.2',
    category: SECTION_CATEGORIES.PARALLEL_FLANGE_CHANNELS,
    standard: 'Aust350',
    properties: {
      fabrication: 'Hot Rolled',
      availability: 'Common',
      d: 380,
      bf: 100,
      tf: 17.5,
      tw: 10,
      r1: 14,
      d1: 345,
      ag: 7030,
      ix: 152e6,
      iy: 6.48e+06,
      zx: 798e3,
      zy: 89400,
      sx: 946e3,
      sy: 161e3,
      rx: 147,
      ry: 30.4,
      j: 491e3,
      iw: 152e9,
      fy: 340,
      fyw: 360,
      fu: 480,
      kf: 1,
      compactnessX: 'nan',
      zex: 946,
      compactnessY: 'nan',
      zey: 104
    }
  })
];
